<template>
    <div style="position: relative;">
        <!-- 轮播图 -->
        <img class="top-nav" src="../assets/tops.png" alt="返回顶部" @click="topOne">
        <NavBar :index="1" />
        <swiper :options="swiperOption" ref="mySwiper" id="mySwiper" class="swiper-no-swiping">
            <!-- 轮播图11 -->
            <swiper-slide class="swiper_slide_item">
                <swiper :options="swiperTop" ref="swiperTop" id="swiperTop">
                    <swiper-slide>
                        <div class="one-card"
                            style=" border-radius: 0; position: relative; width: 100vw; height: 100vh;margin: 0;">
                            <video
                                src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/c7120e8c1b6424c8fd6e13e510616221.mp4"
                                autoplay muted loop
                                style="position: absolute; top: 0; left: 0; width: 100vw; height: 100%; object-fit: cover;"
                                preload="auto">
                            </video>
                            <div class="textara">
                                <div class="text-cons">国内领先的数字经济科技赋能平台</div>
                                <div class="text-fonts">Leading domestic digital economy technology empowerment platform
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <!--分页器-->
                    <!-- <div class="top-pagination" slot="pagination"></div> -->
                </swiper>
                <!-- Tab 导航 - 使用与businessList相同的样式 -->
                <div class="top-business-tabs">
                    <div class="tab-nav">
                        <div v-for="(tab, index) in topTabs" :key="index" :class="['tab-item', { active: index === 0 }]"
                            @click="switchTopTab(index)">
                            {{ tab.name }}
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!--每页幻灯片使用swiper-slide标签-->
            <!-- 1 -->
            <swiper-slide>
                <div style="padding-top: 50px;">
                    <div class="insta">
                        <div class="insta-Tit" :class="activeIndex == 1 ? 'animated-title-second' : ''">智慧谷集团
                        </div>
                        <div class="insta-subtitle " :class="activeIndex == 1 ? 'animated-title-second' : ''">
                            重塑数字生态，数智产业未来
                        </div>
                        <div class="font-con">
                            智慧谷集团是国家级高新技术企业，以“构筑数字经济发展新范式”为使命，矢志成为“全球产业数字化生态建设的百年领军者”。我们以自主研发的智谷链WEC-Dapp-PaaS系统与AI工具链为双核引擎，打造开放协同的产业数字化生态平台，驱动实体经济全链路升级，引领中国数字经济标杆实践。智慧谷集团将持续深化"技术-平台-生态”三位一体战略，携手全球伙伴共筑数字文明新时代!
                        </div>
                        <!-- 内容 -->
                        <div class="backCon">
                            <div class="cardTwo">
                                <!-- 左箭头按钮 -->
                                <div class="left-button" @click="prevCardPage">
                                    <img src="../assets/butzuo.png" alt="">
                                </div>
                                <swiper :autoplay="{
                                    delay: 2000,
                                    disableOnInteraction: false,
                                }" :options="swiperTwo" ref="swiperTwo" id="swiperTwo">
                                    <swiper-slide>
                                        <div class="redice">
                                            <div class="rediceItem">
                                                <div class="rediceItem-title">
                                                    <div class="rediceItem-title-Top">核心优势：技术筑基 生态赋能</div>
                                                    <div class="rediceItem-title-Bottom">双核引擎，引领数字经济标杆</div>
                                                </div>
                                                <div class="rediceItem-content">
                                                    <div class="rediceItem-content-title">
                                                        1.智谷链WEC-Dapp-PaaS系统--分布式应用平台即服务</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span>
                                                        分布式架构:保障系统高并发、高可靠、高安全</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span>
                                                        低代码开发:赋能生态伙伴快速构建数字化应用</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span>弹性部署:支持亿级用户规模的灵活扩展
                                                    </div>
                                                    <div class="rediceItem-content-title" style="margin-top: 20px;">
                                                        1.AI工具链</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span>深度融合3D建模、NFC交互、智能推荐等前沿技术,为生态注入智能化基因
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="rediceItem">
                                                <div class="rediceItem-title">
                                                    <div class="rediceItem-title-Top">核心业务:三位一体全域生态引擎</div>
                                                    <div class="rediceItem-title-Bottom">
                                                        基于Dapp-PaaS+Al双引擎，构建覆盖"人-货-场-资"的数字生态闭环</div>
                                                </div>
                                                <div class="rediceItem-content">
                                                    <div class="rediceItem-content-title">1.智谷AI名片:智能社交入口</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span>
                                                        融合AI、3D数字人、NFC技术，打造沉浸式数字身份</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span>实现社交裂变引流与企业精准营销
                                                    </div>
                                                    <div class="rediceItem-content-title" style="margin-top: 20px;">
                                                        2.数字门店(智慧码):场景连接中枢</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span> “物一码”贯通物理世界与数字空间
                                                    </div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span> 实时沉淀场景数据，驱动运营决策智能化
                                                    </div>
                                                    <div class="rediceItem-content-title" style="margin-top: 20px;">
                                                        3.数商生态(AI数字商城)价值创造平台</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span>
                                                        独创DTO(RWA)订单经济模型:将实体订单转化为数字资产</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span>
                                                        提供“订单到IPO”全栈式服务:整合供应链、金融、上市通路</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span> AI驱动精准营销与生态价值分配
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </swiper-slide>
                                    <swiper-slide>
                                        <div class="redice">
                                            <div class="rediceItem">
                                                <div class="rediceItem-title">
                                                    <div class="rediceItem-title-Top">创新模式：全域生态自循环系统</div>
                                                    <div class="rediceItem-title-Bottom">[社交引流→场景沉淀→资产增值」三位一体飞轮</div>
                                                </div>
                                                <div class="rediceItem-content">
                                                    <div class="rediceItem-content-title">
                                                        AI名片:</div>
                                                    <div class="rediceItem-content-notice"><span
                                                            class="rediceItem-content-round">●</span>
                                                        启动社交裂变→智慧码:实现场景数据闭环→数字商城-通过DTO模型完成订单资产化</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span>
                                                        在Dapp-PaaS+AI平台支撑下,形成“用户增长-数据沉淀-资产流通”的自进化生态网络</div>
                                                </div>
                                            </div>
                                            <div class="rediceItem">
                                                <div class="rediceItem-title">
                                                    <div class="rediceItem-title-Top">核心价值:自主创新·共生跃迁</div>
                                                    <div class="rediceItem-title-Bottom">
                                                        坚守 “技术自主、生态共生、价值共享”三大准则</div>
                                                </div>
                                                <div class="rediceItem-content">
                                                    <div class="rediceItem-content-title">1.技术自主:</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span>
                                                        国产化分布式架构，安全可控的数字基座</div>
                                                    <div class="rediceItem-content-title" style="margin-top: 20px;">
                                                        2.生态共生:</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span>开放平台聚合10万+企业，共享生态红利
                                                    </div>
                                                    <div class="rediceItem-content-title" style="margin-top: 20px;">
                                                        3.价值跃迁:</div>
                                                    <div class="rediceItem-content-notice"> <span
                                                            class="rediceItem-content-round">●</span>DTO模型打通实体资产与数字资本,实现“订单即资产,增长即收益”
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </swiper-slide>
                                    <div class="two-pagination" style="position: absolute;bottom: 30px;"
                                        slot="pagination"></div>
                                </swiper>
                                <!-- 第一张卡片：核心优势 -->
                                <!-- 右箭头按钮 -->
                                <div class="right-button" @click="nextCardPage">
                                    <img src="../assets/butyou.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--分页器-->
            </swiper-slide>
            <!-- 第二块 -->
            <!-- 创始人寄语卡片 -->
            <swiper-slide class="swiper_slide_item">
                <div class="jy-card" style="padding-top: 50px;">
                    <div class="card-Tit" :class="activeIndex == 2 ? 'animated-title-second' : ''">创始人寄语</div>
                    <div class="founder-message-card">
                        <div class="card-header-section">
                            <h2 class="main-title" :class="activeIndex == 2 ? 'animated-partner-row-delay1' : ''">
                                美国有硅谷，中国有智慧谷！
                            </h2>
                        </div>
                        <div class="card-content-section">
                            <div class="founder-info">
                                <div class="founder-avatar" :class="activeIndex == 2 ? 'animated-title-second' : ''">
                                    <img src="../assets/xzggr.png" alt="">
                                </div>
                                <div class="founder-message"
                                    :class="activeIndex == 2 ? 'animated-partner-row-delay1' : ''">
                                    <div class="message-content">
                                        <p class="intro-text">
                                            创始人凭借中医思维管理理念,运用于商业顶层设计、战略发展布局以及产业集群、产业园区孵化加速的营运
                                            思路和政治经济学认知高度,携专家团队立志要搭建“中国智慧谷”智库经济平台,解决中国新兴企业发展的难点痛点,坚定数字经济时代“新赛道”的发展趋势,践行数字科技赋能实体产业为中心,并赋予企业高质量
                                            发展、数字化转型升级有力助推器。
                                        </p>
                                        <div class="message-highlights">
                                            <p class="highlight-item">
                                                【智慧谷】矢志不渝为中国企业合作伙伴提供更全面的软硬件服务与解决方案，开放式融合链接更多的有效高端资源，共建一带一路产业联盟共享平台。</p>
                                            <div class="business-goals">
                                                <p>让中国企业能够走出国门；</p>
                                                <p>让中国品牌能够走向世界；</p>
                                                <p>让世界都能</p>
                                                <p>- 看到中国的产品</p>
                                                <p>- 听到中国的声音</p>
                                                <p>- 领悟到中国的智慧！</p>
                                            </div>
                                            <div class="signature">
                                                <p>集团董事长签名：
                                                <p class="signature-text"><img src="../assets/xzqm.png" alt=""></p>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 企业文化 -->
            <swiper-slide>
                <div style="padding-top: 50px;">
                    <!-- 选项卡导航 -->
                    <div class="development-tabs">
                        <div class="cont-qiye">
                            <div class="contq-Tit" :class="activeIndex == 3 ? 'animated-title-second' : ''">企业文化</div>
                            <div class="contq-sub" :class="activeIndex == 3 ? 'animated-title-second' : ''">
                                让企业更轻、更活、更有价值！</div>
                        </div>
                        <div class="tab-qiye">
                            <div v-for="(tab, index) in developmentTabs" :key="index"
                                :class="['tab-item', { active: developmentTabActive === index }]"
                                @click="switchDevelopmentTab(index)">
                                {{ tab.name }}
                            </div>
                        </div>
                        <!-- 第一页内容 -->
                        <div v-show="developmentTabActive == 0" style="width: 100%;">
                            <div style="min-height: 120px;display: flex;justify-content:space-between;width: 70%;margin-left: 15%;"
                                :class="activeIndex == 3 ? 'animated-partner-row' : ''">
                                <div
                                    style="width: 30%;border-radius:10px;background: #eef3ff;padding: 20px; padding-right: 10px; padding-left: 10px; ">
                                    <div style="display: flex;">
                                        <div style="width: 8%;">
                                            <img style="width: 30px;" src="../assets/qyzz.png" alt="">
                                        </div>
                                        <div style="margin-left: 10px;">
                                            <div style="color:#2D7CFE">企业宗旨</div>
                                            <div class="f-14">构筑“共生、互生、再生”的数字产业生态共同体。</div>
                                        </div>
                                        <div style="width: 10%;"></div>
                                    </div>
                                </div>
                                <div style="min-height: 120px;width: 30%;border-radius:10px;background: #eef3ff;padding: 20px; padding-right: 10px; padding-left: 10px; ">
                                    <div style="display: flex;">
                                        <div style="width: 8%;">
                                            <img style="width: 30px;" src="../assets/qysm.png" alt="">
                                        </div>
                                        <div style="margin-left: 10px;">
                                            <div style="color:#2D7CFE">企业使命</div>
                                            <div class="f-14">以国学韬略淬炼商业智慧，以数字科技驱动产业创新，成就商以致善的行业典范。</div>
                                        </div>
                                        <div style="width: 10%;"></div>
                                    </div>
                                </div>
                                <div
                                    style="min-height: 120px;width: 30%;border-radius:10px;background: #eef3ff;padding: 20px; padding-right: 10px; padding-left: 10px; ">
                                    <div style="display: flex;">
                                        <div style="width: 8%;">
                                            <img style="width: 30px;" src="../assets/qyyy.png" alt="">
                                        </div>
                                        <div style="margin-left: 10px;">
                                            <div style="color:#2D7CFE">企业愿景</div>
                                            <div class="f-14">铸就百年基业，树立百强标杆，传承百匠精神，引领数字文明。</div>
                                        </div>
                                        <div style="width: 10%;"></div>
                                    </div>
                                </div>
                            </div>
                            <div style="height: 30px;"></div>
                            <div style="min-height: 120px;display: flex;justify-content: space-between;width: 70%;margin-left: 15%;"
                                :class="activeIndex == 3 ? 'animated-partner-row-delay1' : ''">
                                <div
                                    style="width: 30%;border-radius:10px;background: #eef3ff;padding: 20px; padding-right: 10px; padding-left: 10px; ">
                                    <div style="display: flex;">
                                        <div style="width: 8%;">
                                            <img style="width: 30px;" src="../assets/fzcl.png" alt="">
                                        </div>
                                        <div style="margin-left: 10px;">
                                            <div style="color:#2D7CFE">企业精神</div>
                                            <div class="f-14">
                                                秉持革新求变之志，顺应与时俱进之势，涵养开放包容之怀，追求卓越至上之境。</div>
                                        </div>
                                        <div style="width: 10%;"></div>
                                    </div>
                                </div>
                                <div
                                    style="min-height: 120px;width: 30%;border-radius:10px;background: #eef3ff;padding: 20px;padding-right: 10px; padding-left: 10px;">
                                    <div style="display: flex;">
                                        <div style="width: 8%;">
                                            <img style="width: 30px;" src="../assets/fzlj.png" alt="">
                                        </div>
                                        <div style="margin-left: 10px;">
                                            <div style="color:#2D7CFE">发展路径</div>
                                            <div class="f-14">聚焦数字三农，驱动三产融合。</div>
                                        </div>
                                        <div style="width: 10%;"></div>
                                    </div>
                                </div>
                                <div
                                    style="min-height: 120px;width: 30%;border-radius:10px;background: #eef3ff;padding: 20px; padding-right: 10px; padding-left: 10px;">
                                    <div style="display: flex;">
                                        <div style="width: 8%;">
                                            <img style="width: 30px;" src="../assets/sgzx.png" alt="">
                                        </div>
                                        <div style="margin-left: 10px;">
                                            <div style="color:#2D7CFE">发展策略</div>
                                            <div class="f-14">聚合政产学研创投力量 共建城市创新加速引擎。</div>
                                        </div>
                                        <div style="width: 10%;"></div>
                                    </div>
                                </div>
                            </div>
                            <div style="height: 30px;"></div>
                            <div style="min-height: 120px;display: flex;justify-content: space-between;width: 70%;margin-left: 15%;"
                                :class="activeIndex == 3 ? 'animated-partner-row' : ''">
                                <div
                                    style="width: 30%;border-radius:10px;background: #eef3ff;padding: 20px; padding-right: 10px; padding-left: 10px;">
                                    <div style="display: flex;">
                                        <div style="width: 8%;">
                                            <img style="width: 30px;" src="../assets/fzsg.png" alt="">
                                        </div>
                                        <div style="margin-left: 10px;">
                                            <div style="color:#2D7CFE">发展三观</div>
                                            <div class="f-14">整体全局观、和合并存观、因果相应观。</div>
                                        </div>
                                        <div style="width: 10%;"></div>
                                    </div>
                                </div>
                                <div
                                    style="min-height: 120px;width: 30%;border-radius:10px;background: #eef3ff;padding: 20px; padding-right: 10px; padding-left: 10px;">
                                    <div style="display: flex;">
                                        <div style="width: 8%;">
                                            <img style="width: 30px;" src="../assets/jsfw.png" alt="">
                                        </div>
                                        <div style="margin-left: 10px;">
                                            <div style="color:#2D7CFE">核心优势</div>
                                            <div class="f-14">自主技术合规备案；数商模型全球独创。聚合通道数据共享；三产融合生态发展。</div>
                                        </div>
                                        <div style="width: 10%;"></div>
                                    </div>
                                </div>
                                <div
                                    style="min-height: 120px;width: 30%;border-radius:10px;background: #eef3ff;padding: 20px; padding-right: 10px; padding-left: 10px;">
                                    <div style="display: flex;">
                                        <div style="width: 8%;">
                                            <img style="width: 30px;" src="../assets/qyjs.png" alt="">
                                        </div>
                                        <div style="margin-left: 10px;">
                                            <div style="color:#2D7CFE">数改甄选</div>
                                            <div class="f-14">地标非遗，上乘食养，国韵定制，赠者有光。</div>
                                        </div>
                                        <div style="width: 10%;"></div>
                                    </div>
                                </div>
                            </div>
                            <div style="height: 30px;"></div>
                            <div style="display: flex;justify-content: space-between;width: 70%;margin-left: 15%;"
                                :class="activeIndex == 3 ? 'animated-partner-row-delay1' : ''">
                                <div
                                    style="min-height: 120px;width: 30%;border-radius:10px;background: #eef3ff;padding: 20px; padding-right: 10px; padding-left: 10px;">
                                    <div style="display: flex;">
                                        <div style="width: 8%;">
                                            <img style="width: 30px;" src="../assets/fzln.png" alt="">
                                        </div>
                                        <div style="margin-left: 10px;">
                                            <div style="color:#2D7CFE">发展理念</div>
                                            <div class="f-14">先用户体验，后共识培育，同数证激励;</div>
                                            <div class="f-14">先订单认筹，后共产进阶，同共享达成。</div>
                                        </div>
                                        <div style="width: 10%;"></div>
                                    </div>
                                </div>
                                <div
                                    style="min-height: 120px;width: 30%;border-radius:10px;background: #eef3ff;padding: 20px; padding-right: 10px; padding-left: 10px;">
                                    <div style="display: flex;">
                                        <div style="width: 8%;">
                                            <img style="width: 30px;" src="../assets/zlsw.png" alt="">
                                        </div>
                                        <div style="margin-left: 10px;">
                                            <div style="color:#2D7CFE">核心业务</div>
                                            <div class="f-14">专注于企业产供销全链路通证化服务，</div>
                                            <div class="f-14">提供“链改+证改+数改”全栈式解决方案。</div>
                                        </div>
                                        <div style="width: 10%;"></div>
                                    </div>
                                </div>
                                <div
                                    style="min-height: 120px;width: 30%;border-radius:10px;background: #eef3ff;padding: 20px; padding-right: 10px; padding-left: 10px;">
                                    <div style="display: flex;">
                                        <div style="width: 8%;">
                                            <img style="width: 30px;" src="../assets/tzyy.png" alt="">
                                        </div>
                                        <div style="margin-left: 10px;">
                                            <div style="color:#2D7CFE">通证应用</div>
                                            <div class="f-14">国家网信办备案应用于智谷链-DApp区块链商城，实现数商生态，并赋能“现货·期货·股票”通证化场景。</div>
                                        </div>
                                        <div style="width: 10%;"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 第二页内容 -->
                        <div v-if="developmentTabActive == 1" style="width:100%;">
                            <div style="min-height: 80px; display: flex;justify-content: space-between;width: 70%;margin-left: 15%;"
                                :class="activeIndex == 3 ? 'animated-partner-row' : ''">
                                <div v-for="(item, index) in secondData"
                                    style="width:31%;  display: flex;justify-content: space-between;flex-wrap: wrap;">
                                    <div
                                        :style="item.showAll ? ' min-height: auto; width: 100%; border-radius:10px; background: #eef3ff; padding: 10px; padding-right: 10px; padding-left: 10px;' : 'height:130px; width: 100%; border-radius:10px; background: #eef3ff;padding: 10px; padding-right: 10px; padding-left: 10px;'">
                                        <div style="display: flex;">
                                            <div style="width: 8%;">
                                                <img style="width: 100%; object-fit: contain; " :src="item.icon" alt="">
                                            </div>
                                            <div style="margin-left: 10px;">
                                                <div style="color:#2D7CFE">{{ item.title }}</div>
                                                <div class="f-14" v-html="item.c1"></div>
                                                <div class="f-14" v-html="item.c2"></div>
                                                <div v-if="item.showAll" class="f-14" v-html="item.hidden"></div>
                                            </div>
                                            <!-- <div style="width: 10%;"></div> -->
                                        </div>
                                        <div style="text-align: center; color:#2D7CFE; margin-top: 10px; font-size: 13px; cursor: pointer;"
                                            @click="lookAll(index)">
                                            {{ item.showAll ? '收起' : '查看全部' }}
                                            <span
                                                style="display: inline-block; margin-left: 5px; transition: transform 0.3s;"
                                                :style="{ transform: item.showAll ? 'rotate(180deg)' : 'rotate(0deg)' }">
                                                ▼
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 2 -->
                            <div style="  margin-top: 20px; min-height: 80px; display: flex;justify-content: space-between;width: 70%;margin-left: 15%;"
                                :class="activeIndex == 3 ? 'animated-partner-row-delay1' : ''">
                                <div v-for="(item, index) in twoData"
                                    style="width:30%;  display: flex;justify-content: space-between;flex-wrap: wrap;">
                                    <div
                                        :style="item.showAlltwoData ? 'min-height: auto; width: 100%; border-radius:10px; background: #eef3ff; padding: 10px; ' : 'height:130px; width: 100%; border-radius:10px; background: #eef3ff; padding: 10px; padding-right: 10px; padding-left: 10px;'">
                                        <div style="display: flex;">
                                            <div style="width: 8%;">
                                                <img style="width: 100%;" :src="item.icon" alt="">
                                            </div>
                                            <div style="margin-left: 10px;">
                                                <div style="color:#2D7CFE">{{ item.title }}</div>
                                                <div class="f-14">{{ item.c1 }}</div>
                                                <div class="f-14">{{ item.c2 }}</div>
                                                <div v-if="item.showAlltwoData" class="f-14" v-html="item.hidden"></div>
                                            </div>
                                            <!-- <div style="width: 10%;"></div> -->
                                        </div>
                                        <div style="text-align: center; color:#2D7CFE; margin-top: 10px; font-size: 13px; cursor: pointer;"
                                            @click="lookAlltwoData(index)">
                                            {{ item.showAlltwoData ? '收起' : '查看全部' }}
                                            <span
                                                style="display: inline-block; margin-left: 5px; transition: transform 0.3s;"
                                                :style="{ transform: item.showAlltwoData ? 'rotate(180deg)' : 'rotate(0deg)' }">
                                                ▼
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 3 -->
                            <div style="  margin-top: 20px; min-height: 80px; display: flex;justify-content: space-between;width: 70%;margin-left: 15%;"
                                :class="activeIndex == 3 ? 'animated-partner-row' : ''">
                                <div v-for="(item, index) in treen"
                                    style="width:30%;  display: flex;justify-content: space-between;flex-wrap: wrap;">
                                    <div
                                        :style="item.showAlltreen ? 'min-height: auto; width: 100%; border-radius:10px; background: #eef3ff; padding: 10px; ' : 'height:130px; width: 100%; border-radius:10px; background: #eef3ff; padding: 10px; padding-right: 10px; padding-left: 10px;'">
                                        <div style="display: flex;">
                                            <div style="width: 8%;">
                                                <img style="width: 100%;" :src="item.icon" alt="">
                                            </div>
                                            <div style="margin-left: 10px;">
                                                <div style="color:#2D7CFE">{{ item.title }}</div>
                                                <div class="f-14">{{ item.c1 }}</div>
                                                <div class="f-14">{{ item.c2 }}</div>
                                                <div v-if="item.showAlltreen" class="f-14" v-html="item.hidden"></div>
                                            </div>
                                            <!-- <div style="width: 10%;"></div> -->
                                        </div>
                                        <div style="text-align: center; color:#2D7CFE; margin-top: 10px; font-size: 13px; cursor: pointer; "
                                            @click="lookAlltreen(index)">
                                            {{ item.showAlltreen ? '收起' : '查看全部' }}
                                            <span
                                                style="display: inline-block; margin-left: 5px; transition: transform 0.3s;"
                                                :style="{ transform: item.showAlltreen ? 'rotate(180deg)' : 'rotate(0deg)' }">
                                                ▼
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 4 -->
                            <div style=" margin-top: 20px; min-height: 80px; display: flex;justify-content: space-between;width: 70%;margin-left: 15%;"
                                :class="activeIndex == 3 ? 'animated-partner-row-delay1' : ''">
                                <div v-for="(item, index) in fours"
                                    style="width:30%;  display: flex;justify-content: space-between;flex-wrap: wrap;">
                                    <div
                                        :style="item.showAllfours ? 'min-height: auto; width: 100%; border-radius:10px; background: #eef3ff; padding: 10px; ' : 'height:130px; width: 100%; border-radius:10px; background: #eef3ff; padding: 10px; padding-right: 10px; padding-left: 10px;'">
                                        <div style="display: flex;">
                                            <div style="width: 8%;">
                                                <img style="width: 100%;" :src="item.icon" alt="">
                                            </div>
                                            <div style="margin-left: 10px;">
                                                <div style="color:#2D7CFE">{{ item.title }}</div>
                                                <div class="f-14">{{ item.c1 }}</div>
                                                <div class="f-14">{{ item.c2 }}</div>
                                                <div v-if="item.showAllfours" class="f-14" v-html="item.hidden"></div>
                                            </div>
                                            <!-- <div style="width: 10%;"></div> -->
                                        </div>
                                        <div style="text-align: center; color:#2D7CFE; margin-top: 10px; font-size: 13px; cursor: pointer;"
                                            @click="lookAllfours(index)">
                                            {{ item.showAllfours ? '收起' : '查看全部' }}
                                            <span
                                                style="display: inline-block; margin-left: 5px; transition: transform 0.3s;"
                                                :style="{ transform: item.showAllfours ? 'rotate(180deg)' : 'rotate(0deg)' }">
                                                ▼
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 第4 发展纲要4-->
            <swiper-slide class="swiper_slide_item">
                <div class="fazhan" style="padding-top: 50px;">
                    <div class="fazhan-Tit" :class="activeIndex == 4 ? 'animated-title-second' : ''">发展纲要</div>
                    <div class="fazhan-subtitle" :class="activeIndex == 4 ? 'animated-title-second' : ''">数字赋能，生态共荣
                    </div>
                    <!-- 发展战略模块容器 -->
                    <div class="strategy-row first-row" :class="activeIndex == 4 ? 'animated-partner-row' : ''">
                        <div class="strategy-item" v-for="(a, index) in firstRowItems" :key="index"
                            :class="{ 'expanded': expandedItem === index }" :style="{
                                'min-height': ((index === 1 && expandedItem === index) || (index === 2 && expandedItem === index)) ? '420px' : ''
                            }">
                            <div class="strategy-content-wrapper">
                                <div class="strategy-icon">
                                    <img :src="a.icon">
                                </div>
                                <div class="strategy-title">{{ a.title }}</div>
                                <div class="strategy-subtitle" style="color: #2D7CFE;">{{ a.subtitle }}</div>
                                <div class="strategy-subtitle" v-html="a.description">
                                </div>
                                <div class="strategy-content" v-html="a.hides">
                                </div>
                                <div class="expand-icon" @click="toggleExpand(index)" v-if="expandedItem !== index">
                                    <img src="../assets/butbot.png" alt="">
                                </div>
                                <div class="expand-icon" @click="toggleExpand(index)" v-if="expandedItem === index">
                                    <img src="../assets/butop.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 第二块 -->
                    <div class="strategy-row second-row" :class="activeIndex == 4 ? 'animated-partner-row-delay1' : ''">
                        <div class="strategy-item" v-for="(a, index) in secondRowItems" :key="index + 5"
                            :class="{ 'expanded': expandedItem === (index + 5) }">
                            <div class="strategy-content-wrapper">
                                <div class="strategy-icon">
                                    <img :src="a.icon">
                                </div>
                                <div class="strategy-title">{{ a.title }}</div>
                                <div class="strategy-subtitle" style="color: #2D7CFE;">{{ a.subtitle }}</div>
                                <div class="strategy-subtitle">
                                    <p v-html="a.description"></p>
                                </div>
                                <div class="strategy-content">
                                    <p v-html="a.hides"></p>
                                </div>
                                <div class="expand-icon" @click="toggleExpand(index + 5)"
                                    v-if="expandedItem !== (index + 5)">
                                    <img src="../assets/butbot.png" alt="">
                                </div>
                                <div class="expand-icon" @click="toggleExpand(index + 5)"
                                    v-if="expandedItem === (index + 5)">
                                    <img src="../assets/butop.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 发展历程 -->
            <swiper-slide class="swiper_slide_item">
                <div class="big-one">
                    <div class="time-fonts">
                        <div class="time-text" :class="activeIndex == 5 ? 'animated-partner-row' : ''">智谷链发展历程</div>
                        <p class="subtit" :class="activeIndex == 5 ? 'animated-partner-row' : ''">坚持数字触达万物，坚定数字落地赋能</p>
                    </div>
                    <!-- big-time 结构 -->
                    <div class="big-time">
                        <div class="time-con">
                            <div class="time-round">
                                <div class="big-round">
                                    <img src="../assets/round.png" class="round-img"
                                        :class="activeIndex == 5 ? 'round-ones' : ''" />
                                    <img src="../assets/zhou.png" class="axis-img"
                                        :class="activeIndex == 5 ? 'axis-ones' : ''" />
                                    <!-- 上方节点 -->
                                    <div class="time-top">
                                        <div class="time-item">
                                            <img src="../assets/erer.png" alt=""
                                                :class="activeIndex == 5 ? 'fade-in-1' : ''" />
                                            <img src="../assets/eoeos.png" alt=""
                                                :class="activeIndex == 5 ? 'fade-in-2' : ''" />
                                            <img src="../assets/ybss.png" alt=""
                                                :class="activeIndex == 5 ? 'fade-in-3' : ''" />
                                            <img src="../assets/yl.png" alt=""
                                                :class="activeIndex == 5 ? 'fade-in-4' : ''" />
                                        </div>
                                    </div>
                                    <!-- 下方节点（新增） -->
                                    <div class="time-bottom">
                                        <div class="time-item">
                                            <img src="../assets/eses.png" alt=""
                                                :class="activeIndex == 5 ? 'fade-in-1' : ''" />
                                            <img src="../assets/eyey.png" alt=""
                                                :class="activeIndex == 5 ? 'fade-in-2' : ''" />
                                            <img src="../assets/yj.png" alt=""
                                                :class="activeIndex == 5 ? 'fade-in-3' : ''" />
                                            <img src="../assets/yq.png" alt=""
                                                :class="activeIndex == 5 ? 'fade-in-4' : ''" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 专家团队 -->
            <swiper-slide class="swiper_slide_item">
                <div class="zhuan-con">
                    <div>
                        <div class="insta-Tits" :class="activeIndex == 6 ? 'animated-title-second' : ''">专家团队 </div>
                        <div class="insta-subtitles" :class="activeIndex == 6 ? 'animated-title-second' : ''">
                            智慧谷集聚区块链及数改行业领军人物,全方位解读十四五规划及大环境趋势,深度认知行业现状本质,完美构建智慧谷可持续性发展规划蓝图。
                        </div>
                    </div>
                    <div class="expert-container">
                        <!-- 右侧一个大的专家卡片 -->
                        <div class="right-expert" :class="activeIndex == 6 ? 'animated-partner-row' : ''">
                            <div class="item-contan-larges">
                                <div>
                                    <ul style=" padding-left: 20px;list-style-type: disc;width: 90%;margin-left: 6%;">
                                        <li>
                                            上海通用化工技术研究所所长
                                        </li>
                                        <li>SO/IEC JTC1/SC6/WG7未来网络中国国家成员体中国专家</li>
                                        <li>工业和信息化部新一代安全可控信息网络技术</li>
                                        <li>平台总体设计专家组组长</li>
                                        <li>在信息技术中的IPV9协议、未来网络四层三层混合架构、新一代安全可控信息技术平台</li>
                                        <li>十进制网络示范工程等方向取得了突破性的研究成果。</li>
                                    </ul>
                                    <div style="height: 30px;"></div>
                                </div>
                                <img src="../assets/xjp.png"
                                    style="width:90%; position: absolute;left: -10%;bottom: -10%">
                            </div>
                        </div>
                        <!-- 左侧四个专家卡片 -->
                        <div class="left-experts" :class="activeIndex == 6 ? 'animated-partner-row-delay1' : ''">
                            <!-- 第一行两个专家 -->
                            <div class="expert-row">
                                <div class="item-contan">
                                    <div>
                                        <ul
                                            style="padding-left: 20px;list-style-type: disc;width: 90%;margin-left: 9%;">
                                            <li>
                                                中国文物学会会员
                                            </li>
                                            <li>艺术品高级鉴定师</li>
                                            <li>翡翠高级鉴定师、鉴定评估师</li>
                                            <li>中国爱新觉罗皇家文化保护委员会陶瓷鉴定专家</li>
                                            <li>国鉴通首席鉴定师</li>
                                            <li>粤港澳大湾区古代艺术品交易所指定专家</li>
                                        </ul>
                                        <div style="height: 30px;"></div>
                                    </div>
                                    <img src="../assets/qgl.png"
                                        style="width: 55%;position: absolute;left: -7%;bottom: -20%">
                                </div>
                                <div class="item-contan"
                                    style="background: linear-gradient( 180deg, #FFFFFF 0%, #EAF1FF 100%);border: 1px dashed #2D7CFE;">
                                    <div>
                                        <ul
                                            style="padding-left: 20px;list-style-type: disc;width: 90%;margin-left: 6%;">
                                            <li>数字经济学家</li>
                                            <li>中国移动通信联合会区块链专委会主任</li>
                                            <li>国家区块链经济课题研究小组副组长兼秘书长</li>
                                        </ul>
                                        <div style="height: 30px;"></div>
                                    </div>
                                    <img src="../assets/cxh.png"
                                        style="width: 60%;position: absolute;left: -7%;bottom: -20%">
                                </div>
                            </div>
                            <!-- 第二行两个专家 -->
                            <div class="expert-row">
                                <div class="item-contan">
                                    <div>
                                        <ul
                                            style="padding-left: 20px;list-style-type: disc;width: 90%;margin-left: 9%;">
                                            <li>经济学家、莫干山研究院学术委员会联席主任</li>
                                            <li>横琴数链数字研究院学术与技术委员会主席</li>
                                            <li>数字资产研究院(CIDA)学术与技术委员会主席</li>
                                            <li>是国内最早关注“元宇宙”概念的专家之一</li>
                                        </ul>
                                        <div style="height: 30px;"></div>
                                    </div>
                                    <img src="../assets/zjm.png"
                                        style="width: 60%;position: absolute;left: -7%;bottom: -20%">
                                </div>
                                <div class="item-contan"
                                    style="background: linear-gradient( 180deg, #FFFFFF 0%, #EAF1FF 100%);border: 1px dashed #2D7CFE;">
                                    <div>
                                        <ul
                                            style="padding-left: 20px;list-style-type: disc;width: 90%;margin-left: 9%;">
                                            <li>中关村区块链产业联盟理事长</li>
                                            <li>成都信息工程大学特聘教授</li>
                                            <li>中国互联网协会常务理事</li>
                                            <li>中国信息化百人会理事</li>
                                            <li>清华大学互联网产业研究院副理事长</li>
                                            <li>中央财经大学区块链联合实验室学术委员会副主任委员</li>
                                        </ul>
                                        <div style="height: 30px;"></div>
                                    </div>
                                    <img src="../assets/yd.png"
                                        style="width:60%;position: absolute;left: -9%;bottom: -20%">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 企业荣誉 -->
            <swiper-slide>
                <div style="padding-top: 80px;">
                    <div :class="activeIndex == 7 ? 'animated-title-second' : ''"
                        style=" width: 100%; display: flex; align-items: center; justify-content: center; font-size: 28px;font-weight: bold;display: flex;padding-left: 10px;padding-right: 10px;">
                        企业荣誉</div>
                    <!-- 企业荣誉选项卡 -->
                    <div class="enterprise-honor-tabs">
                        <div class="honor-tabs-container">
                            <div class="honor-tab-wrapper">
                                <div class="honor-tab" :class="{ 'active': honorActiveTab === 'certification' }"
                                    @click="switchHonorTab('certification')">
                                    <span>国家认证</span>
                                </div>
                            </div>
                            <div class="honor-tab-wrapper">
                                <div class="honor-tab" :class="{ 'active': honorActiveTab === 'innovation' }"
                                    @click="switchHonorTab('innovation')">
                                    <span>技术创新</span>
                                </div>
                            </div>
                            <div class="honor-tab-wrapper">
                                <div class="honor-tab" :class="{ 'active': honorActiveTab === 'market' }"
                                    @click="switchHonorTab('market')">
                                    <span>市场认可</span>
                                </div>
                            </div>
                        </div>

                        <!-- 选项卡内容 -->
                        <div class="honor-content">
                            <!-- 国家认证内容 -->
                            <div v-if="honorActiveTab === 'certification'" class="honor-panel">
                                <div class="honor-block"
                                    style="position: relative; height: 600px;  box-sizing: border-box;">
                                    <p class="honor-description">
                                        国内首批网信办备案企业，营业区块链体系建设开发的领跑者，国家级高新技术企业
                                    </p>
                                    <div
                                        style="padding-left: 230px; box-sizing: border-box; padding-right: 230px;  display: flex;justify-content: space-around;width: 100%;  z-index: 999;position: absolute;bottom: 260px;">
                                        <div style="width: 400px;display: flex;justify-content: center;">
                                            <img style="width: 100%;" src="../assets/c.png" alt=""
                                                :class="activeIndex == 7 ? 'animated-partner-row' : ''">
                                        </div>
                                        <div style="width: 400px;display: flex;justify-content: center;"
                                            :class="activeIndex == 7 ? 'animated-partner-row-delay1' : ''">
                                            <img style="width: 100%;" src="../assets/b.png" alt="">
                                        </div>
                                    </div>
                                    <div
                                        style=" padding-left: 230px; box-sizing: border-box; padding-right: 230px;  display: flex;justify-content: space-around;width: 100%;position: absolute; bottom: 0px;">
                                        <div style="width: 430px;display: flex;justify-content: center;position: relative;"
                                            :class="activeIndex == 7 ? 'animated-partner-row' : ''">
                                            <img style="width: 100%;" src="../assets/opacity.png" alt="">
                                            <div
                                                style="position: absolute;text-align: center;color: #fff;bottom: 40%;left: 20%;font-size: 24px;">
                                                <p>国家网信办</p>
                                                <p>备案企业</p>
                                            </div>
                                        </div>
                                        <div style="width: 430px;display: flex;justify-content: center;position: relative;"
                                            :class="activeIndex == 7 ? 'animated-partner-row-delay1' : ''">
                                            <img style="width: 100%;" src="../assets/opacity.png" alt="">
                                            <div
                                                style="position: absolute;text-align: center;color: #fff;bottom: 40%;left: 20%;font-size: 24px;">
                                                <p>国家级</p>
                                                <p>高新技术企业</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 技术创新内容 -->
                            <div v-if="honorActiveTab === 'innovation'" class="honor-panel">
                                <div
                                    style="width: 55%;margin-left: 22.5%;display:flex;align-items: center;justify-content: space-between;margin-top: 100px;">
                                    <div style="width: 39%;padding: 40px;color: #2D7CFE;background: linear-gradient(to bottom, #EAF3FF 0%, #C2D9FF 40%, #C2D9FF 60%, #EAF3FF 100%);"
                                        :class="activeIndex == 7 ? 'animated-partner-row' : ''">
                                        <div style="display: flex;justify-content: space-around;">
                                            <div style="text-align: center;">
                                                <div>发明专利</div>
                                                <div style="display: flex;align-items: center;justify-content: center;">
                                                    <p style="font-size: 40px;font-weight: 1000;">6</p>
                                                    <p style="font-size: 20px;">+</p>
                                                </div>
                                            </div>
                                            <div style="text-align: center;">
                                                <div>实用新型专利</div>
                                                <div style="display: flex;align-items: center;justify-content: center;">
                                                    <p style="font-size: 40px;font-weight: 1000;">10</p>
                                                    <p style="font-size: 14px;">+</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div style="height: 30px;"></div>
                                        <div style="display: flex;justify-content: space-around;">
                                            <div style="text-align: center;">
                                                <div>软件著作</div>
                                                <div style="display: flex;align-items: center;justify-content: center;">
                                                    <p style="font-size: 40px;font-weight: 1000;">40</p>
                                                    <p style="font-size: 20px;">+</p>
                                                </div>
                                            </div>
                                            <div style="text-align: center;">
                                                <div>专利受理</div>
                                                <div style="display: flex;align-items: center;justify-content: center;">
                                                    <p style="font-size: 40px;font-weight: 1000;">8</p>
                                                    <p style="font-size: 20px;">+</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 60%;"
                                        :class="activeIndex == 7 ? 'animated-partner-row-delay1' : ''">
                                        <img src="../assets/zs.png" style="width: 100%;" alt="">
                                    </div>
                                </div>
                            </div>
                            <!-- 市场认可内容 -->
                            <!-- honorActiveTab === 'market' 区域 -->
                            <div v-if="honorActiveTab === 'market'" class="honor-panel">
                                <div class="market-carousel-wrapper">
                                    <!-- 左按钮 -->
                                    <div class="left-buttons carousel-nav-btn" @click="prevMarketSlide">
                                        <img src="../assets/butzuo.png" alt="上一页">
                                    </div>
                                    <!-- Swiper -->
                                    <swiper :autoplay="{ delay: 2000, disableOnInteraction: false }"
                                        :options="swiperbotom" ref="swiperbotom" id="swiperbotom">
                                        <!-- 第一页 -->
                                        <swiper-slide>
                                            <div class="market-images-container">
                                                <div class="market-image-item"><img src="../assets/hgzs.png" alt="图1" />
                                                </div>
                                                <div class="market-image-item"><img src="../assets/wwwz.png" alt="图2" />
                                                </div>
                                                <div class="market-image-item"><img src="../assets/ppdh.png" alt="图3" />
                                                </div>
                                            </div>
                                        </swiper-slide>
                                        <!-- 第二页 -->
                                        <swiper-slide>
                                            <div class="market-images-container">
                                                <div class="market-image-item" style="width: 320px;"><img
                                                        src="../assets/sca.jpg" alt="图4" />
                                                </div>
                                                <div class="market-image-item" style="width: 320px;"><img
                                                        src="../assets/scb.png" alt="图5" />
                                                </div>
                                                <div class="market-image-item" style="width: 320px;"><img
                                                        src="../assets/scf.jpg" alt="图6" />
                                                </div>
                                                <div class="market-image-item" style="width: 320px;"><img
                                                        src="../assets/scg.jpg" alt="图6" />
                                                </div>
                                            </div>
                                        </swiper-slide>
                                        <!-- 第三页 -->
                                        <swiper-slide>
                                            <div class="market-images-container">
                                                <div class="market-image-item" style="width: 320px;"><img
                                                        src="../assets/sch.jpg" alt="图7" />
                                                </div>
                                                <div class="market-image-item" style="width: 320px;"><img
                                                        src="../assets/oo.jpg" alt="图8" />
                                                </div>
                                                <div class="market-image-item" style="width: 320px;"><img
                                                        src="../assets/scg.jpg" alt="图9" />
                                                </div>
                                                <div class="market-image-item" style="width: 320px;"><img
                                                        src="../assets/scv.png" alt="图9" />
                                                </div>
                                            </div>
                                        </swiper-slide>
                                        <div class="swiperbotom" slot="pagination"></div>
                                    </swiper>
                                    <!-- 右按钮 -->
                                    <div class="right-buttons carousel-nav-btn" @click="nextMarketSlide">
                                        <img src="../assets/butyou.png" alt="下一页">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!-- 可选的控件 -->
            <swiper-slide class="swiper_slide_item">
                <!-- 底部 -->
                <div class="card-imgs " :class="activeIndex == 8 ? 'animated-image' : ''">
                    <video
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/901c15307e666d31943878a152a23e61_raw.mp4"
                        autoplay muted loop style="width: 100%; height: 100%;  object-fit: cover;" preload="auto">
                    </video>
                    <div class="gradient-con">
                        <div class="gradient-text ">链上生态互融 共享数字未来</div>
                        <div class="gradient-p">智慧谷-您的企业数改服务商</div>
                    </div>
                </div>
                <div class="footer" :class="activeIndex == 8 ? 'animated-image' : ''">
                    <div class="footer_top">
                        <!-- 左 -->
                        <div class="footerTopLeft">
                            <!-- 1 -->
                            <div class="LeftCon" style="cursor: pointer;">
                                <h4 @click="jumps(0)">走进智慧谷</h4>
                                <p @click="jumps(1)">集团介绍</p>
                                <p @click="jumps(5)">发展历程</p>
                                <p @click="jumps(7)">企业荣誉</p>
                            </div>
                            <div class="LeftCon" style="cursor: pointer;">
                                <h4 @click="jumphx(0)">核心业务</h4>
                                <p @click="jumphx(5)">CHAIN企业链改服务</p>
                                <p @click="jumphx(8)">企链通DAPP数商平台</p>
                                <p @click="jumphx(11)">智慧谷AI名片</p>
                            </div>
                            <div class="LeftCon" style="cursor: pointer;">
                                <h4 @click="jumpcj(0)">应用场景</h4>
                                <p @click="jumpcj(2)">数字支付</p>
                                <p @click="jumpcj(3)">数字商城</p>
                                <p @click="jumpcj(19)">数字三农</p>
                            </div>
                            <div class="LeftCon" style="cursor: pointer;">
                                <h4 @click="jumpgh(0)">合作规划</h4>
                                <p @click="jumpgh(1)">合作流程</p>
                                <p @click="jumpgh(2)">合作收益</p>
                                <p @click="jumpgh(4)">全球战略</p>
                            </div>
                        </div>
                        <!-- 右 -->
                        <div class="footerTopRight">
                            <!-- 1 -->
                            <!-- <div class="RightCon" style="font-size: 20px;">
						<p style="cursor: pointer;">联系我们</p>
					</div> -->
                            <div class="RightCon">
                                <img src="../assets/tel.png" mode=""></img>
                                <p>电话：400-8537-168</p>
                            </div>
                            <div class="RightCon">
                                <img src="../assets/web.png" mode=""></img>
                                <p style="cursor: pointer;">网址：www.gjzhg.com</p>
                            </div>
                            <div class="RightCon">
                                <img src="../assets/email.png" mode=""></img>
                                <p style="cursor: pointer;">邮箱：zhgjt@gjzhg.com</p>
                            </div>
                            <div class="RightCon">
                                <img src="../assets/dz.png" mode=""></img>
                                <p style="cursor: pointer;">地址：福建省厦门市集美区杏林湾营运中心总部大厦6号楼</p>
                            </div>
                            <!-- code -->
                            <div class="code">
                                <div
                                    style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                                    <img src="../assets/gzh.jpg" alt=""
                                        style="width: 90px;height: 90px;border-radius: 10px;">
                                    <h5 style="cursor: pointer;">扫一扫关注我们</h5>
                                </div>
                                <div
                                    style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                                    <img src="../assets/kf.png" alt=""
                                        style="width: 90px;height: 90px;border-radius: 10px;">
                                    <h5 style="cursor: pointer;">扫一扫添加客服</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="footer_botm">
                        <p style="text-indent:1em;">版权所有：智慧谷(福建)数字科技集团有限公司</p>
                        <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                        <p style="text-indent:1em;">闽ICP备16005520号-1</p>
                        <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                        <p style="text-indent:1em;">本网站由阿里云提供云计算及安全服务 </p>
                        <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                        <p style="text-indent:1em;"> 本网站支持 IPv6 </p>
                        <p style="text-indent:1em;">|</p>
                        <p style="text-indent:1em;"> Powered by CloudDream </p>
                    </div>
                </div>
            </swiper-slide>
            <!--分页器-->
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>
<script>
import NavBar from '../components/NavBar.vue';
export default {
    components: {
        NavBar
    },
    name: "FullPage",
    data() {
        return {
            developmentTabActive: 0,
            businessActive: 0,
            developmentTabs: [
                { name: '第一篇' },
                { name: '第二篇' }
            ],
            activeIndex: 0,
            newsData: [],//循环新闻
            topTabActive: 0,//轮播图上的tab
            topTabs: [
                { name: '集团介绍' },
                { name: '创始人寄语' },
                { name: '企业文化' },
                { name: '发展纲要' },
                { name: '发展历程' },
                { name: '专家团队' },
                { name: '企业荣誉' }
            ],
            currentTab: 'first',
            currentModule: 0, // 当前显示的模块索引
            isExpanded: false, // 是否展开查看全部
            expandedItem: -1,
            cardPageIndex: 0,
            // 第一排数据
            firstRowItems: [
                {
                    icon: require('../assets/ygzx.png'),
                    title: '一核引领',
                    subtitle: '智驱产业新未来',
                    description: '以数字科技为核心引擎，融合大数据、区块链、人工智能等前沿技术',
                    hides: '推动实体产业实现通证化、数字化与绿色化转型，重塑生产、运营及管理模式，树立产业智能化升级的行业标杆。'
                },
                {
                    icon: require('../assets/lbsl.png'),
                    title: '双轮驱动',
                    subtitle: '协同擘画新蓝图 ',
                    description: '四流贯通：夯实运营基石,资金流高效安全、货物流精准透明、票据流全程可溯、合约流规范可信，四流协同保障企业全链路高效运转。',
                    hides: '四链融合：激活增长新动能产业链优化重构、区块链深度融合、客户链精准运营、生态链开放共生，四链联动构筑可持续发展的产业新生态。'
                },
                {
                    icon: require('../assets/sdql.png'),
                    title: '三鼎筑基',
                    subtitle: '构筑可信商业体系',
                    description: '三确立真：奠定信任根基确真（品质溯源）、确权（权益保障）、确值（价值锚定），从源头构建真实、可信、可溯的合作基础。',
                    hides: '三证提质：强化品质公信验证（质量把控）、认证（标准符合）、鉴证（行为存证），系统提升企业市场信誉与品牌背书。<br/>三权明晰：保障发展权益财权（收益保障）、数权（算法共识）、物权（产权清晰），以制度化体系护航企业行稳致远。'
                },
                {
                    icon: require('../assets/shjg.png'),
                    title: '四化协同',
                    subtitle: '重塑产业价值格局',
                    description: '数据价值化：激活数据要素，赋能智能决策与客户运营；<br/>数权机理化：构建透明、公平的数字权益机制，凝聚发展共识',
                    hides: '数字产业化：培育数字新业态，打造经济新增长极；<br/>产业数字化：引领传统产业智能化转型，焕发发展新活力。'
                },
                {
                    icon: require('../assets/wthl.png'),
                    title: '五体互联',
                    subtitle: '共筑产业命运共同体',
                    description: '战略体系定方向、价值体系塑核心、运营体系提效能、品牌体系扩影响、产业体系促融合',
                    hides: '五体协同构建开放、共生、繁荣的产业生态。'
                }
            ],
            // 第二排数据
            secondRowItems: [
                {
                    icon: require('../assets/lzjz.png'),
                    title: '六自协同',
                    subtitle: '构建发展闭环',
                    description: '自主研发构筑技术护城河、自建生态实现价值共赢、自创服务精准响应用户、自有场景优化全链体验',
                    hides: '自生数证激活资产价值、自链数据释放要素潜能，六自一体实现全链路闭环布局。'
                },
                {
                    icon: require('../assets/qwfn.png'),
                    title: '七维融合',
                    subtitle: '助推企业智变跃升',
                    description: '技术赋能（系统链改）、通证赋能（资产数字化）、方案赋能（战略设计）、信用赋能（数据增信）、品牌赋能（信任加持）',
                    hides: '流量赋能（精准连接）、智库赋能（智力支撑），七维一体全面驱动企业数字化转型升级。'
                },
                {
                    icon: require('../assets/btbz.png'),
                    title: '八统合一',
                    subtitle: '夯实体系化运营根基',
                    description: '统一文化品牌、发展理念、营运规划、数商模型、管理体系',
                    hides: '共识机制、人才机制、福利体系，构建标准化、系统化、可持续的现代化运营体系。'
                },
                {
                    icon: require('../assets/jdcy.png'),
                    title: '九心凝聚',
                    subtitle: '铸就核心团队力量',
                    description: '匠心追求品质、专心铸就专业、细心成就完美、耐心应对挑战、诚心守护合作、热心回馈社会',
                    hides: '信心驱动创新、决心实现目标、恒心坚守使命，九心归一凝聚企业核心竞争力与团队战斗力。'
                },
                {
                    icon: require('../assets/sjfz.png'),
                    title: '十阶演进',
                    subtitle: '迈向万亿数字生态',
                    description: '智库汇聚智慧→布局全球市场→百城产业孵化→千县示范推广→万企链改升级→十万创业扶持→百万优品培育→',
                    hides: '千万用户连接→亿万数据融通→万亿平台引领，十阶递进打造具有全球影响力的数字商业生态，成就万亿级数字经济领军企业。'
                }
            ],
            // 企业文化
            secondData: [
                {
                    title: '技术硬核',
                    c1: '全栈自主的技术底座；驱动价值的智能中台；',
                    c2: '开放协同的数字生态；无界流通的价值网络。',
                    // hidden: '通证兀生;权威认证分布防御;多端兼容;<br/>开放应用;跨网融合。',
                    icon: require('../assets/fzcy.png'),
                    showAll: false
                }, {
                    title: '运营方略',
                    c1: '一链万企系统化;数据确权资产化；<br/>数证红包多元化;权益合约数权化；',
                    c2: '',
                    hidden: 'DTO订单通证化新质生产共识化；<br/>卡券证码数字化以物易物通兑化；<br/>聚合通付数智化共同富裕体系化。',
                    icon: require('../assets/yyfl.png'),
                    showAll: false
                }, {
                    title: '核心思想',
                    c1: '新链接—重新定义合作关系；',
                    c2: '新赛道—重新构建商业逻辑；',
                    hidden: '新思维—重新认知消费资本；<br/>新经济—重新解码数据财富；<br/>新纪元—重新学识通证经济。 ',
                    icon: require('../assets/hxsx.png'),
                    showAll: false
                },
            ],

            twoData: [
                {
                    title: '管理方法',
                    c1: '三权分治管理;【财权、物权、数权】',
                    c2: '三正并举管理;【正知、正念、正行】',
                    hidden: '三公联动管理。【公平、公正、公开】',
                    icon: require('../assets/glff.png'),
                    showAlltwoData: false
                }, {
                    title: '解决痛点',
                    c1: '为消费者：打造“消费无痛”体验；',
                    c2: '为生产者：实现“营销无感”运营；',
                    hidden: '为创业者：提供“创投无忧”保障；<br/>为企业家：驱动“四维价值”最大化。',
                    icon: require('../assets/jjtd.png'),
                    showAlltwoData: false
                }, {
                    title: '运营思路',
                    c1: '把竞争转化为合作，把消费升级为投资，',
                    c2: '把用户转变为股东，把流量转型为资本，',
                    hidden: '把数据改变为资产，把经验沉淀为标准，<br/>把文化提升为品牌，把公益升华为商业。',
                    icon: require('../assets/yysl.png'),
                    showAlltwoData: false
                },
            ],
            treen: [
                {
                    title: '发展倡议',
                    c1: '坚持诚信廉洁、民主自治原则；',
                    c2: '遵循严谨精进、共创共生目标。',
                    // hidden: '隐藏内容',
                    icon: require('../assets/fzcy.png'),
                    showAlltreen: false
                }, {
                    title: '平台格言与企业誓言',
                    c1: '数字重塑生态，数智赋能实体，',
                    c2: '数链重构商业，数证保障信任，',
                    hidden: '数据创造价值，数权驱动经济。<br/>以国链之器，守数据主权；<br/>以数字之道，助民族复兴；<br/>以未来电商，链通世界；<br/>以实数融合，富强中国。',
                    icon: require('../assets/ptgy.png'),
                    showAlltreen: false
                }, {
                    title: '战略定位与思维',
                    c1: '构建数据价值化生态，赋能企业通证化创新。',
                    c2: '用哲学思维定方向，用趋势思维看未来，',
                    hidden: '用数据思维找机会，用系统思维做规划，<br/>用谋略思维去执行，用法治思维守底线。',
                    icon: require('../assets/zldw.png'),
                    showAlltreen: false
                },
            ],

            fours: [
                {
                    title: '团队文化',
                    c1: '感恩【金】，仁爱【水】，责任【木】，',
                    c2: '热情【火】，尊重【土】。',
                    // hidden: '隐藏内容',
                    icon: require('../assets/tdwh.png'),
                    showAllfours: false
                }, {
                    title: '振兴三农',
                    c1: '让手机成为“新农具”，',
                    c2: '让数据成为“新农资”，',
                    hidden: '让直播带货成为“新农活"。',
                    icon: require('../assets/zxsn.png'),
                    showAllfours: false
                }, {
                    title: '教培方针',
                    c1: '人·企合一；知·行合一；产·销合一；',
                    c2: '数·实合一；舍·得合一；成·败合一；',
                    hidden: '政·经合一；德·财合一；',
                    icon: require('../assets/jyfz.png'),
                    showAllfours: false
                },
            ],
            isStrategyExpanded: false, // 是否展开显示全部内容
            selectedStrategy: -1, // 当前选中的战略项目
            honorActiveTab: 'certification', // 企业荣誉选项卡激活状态
            // 市场认可轮播相关数据
            marketCurrentSlide: 0, // 当前轮播页
            marketTotalSlides: 3, // 总轮播页数
            swiperbotomInex: 0,
            // swiper 配置
            swiperOption: {
                direction: "vertical", // swiper 方向
                mousewheel: true,
                // 分页器
                pagination: {
                    el: ".swiper-pagination", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 记录当前页index
                        this.activeIndex = this.$refs.mySwiper.$swiper.activeIndex
                        console.log(this.activeIndex, ' this.activeIndex')
                    },
                }
            },
            // 顶部
            swiperTop: {
                direction: "horizontal", // swiper 方向
                mousewheel: true,
                // autoplay: { delay: 13000, disableOnInteraction: false },
                // 分页器
                pagination: {
                    el: ".top-pagination", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 同步tab状态
                        if (this.$refs.swiperTop && this.$refs.swiperTop.$swiper) {
                            this.topTabActive = this.$refs.swiperTop.$swiper.activeIndex;
                        }
                    },
                }
            },
            swiperTwo: {
                direction: "horizontal", // swiper 方向
                mousewheel: true,
                loop: true,
                // autoplay: { delay: 13000, disableOnInteraction: false },
                // 分页器
                pagination: {
                    el: ".two-pagination", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 同步tab状态
                        if (this.$refs.swiperTwo && this.$refs.swiperTwo.$swiper) {
                            this.cardPageIndex = this.$refs.swiperTwo.$swiper.activeIndex;
                        }
                    },
                }
            },


            // 市场认可
            swiperbotom: {
                direction: "horizontal", // swiper 方向
                mousewheel: true,
                loop: true,
                autoplay: { delay: 13000, disableOnInteraction: false },
                // 分页器
                pagination: {
                    el: ".swiperbotom", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 同步tab状态
                        if (this.$refs.swiperbotom && this.$refs.swiperbotom.$swiper) {
                            this.swiperbotomInex = this.$refs.swiperbotom.$swiper.swiperbotomInex;
                        }
                    },
                }
            },
            //企业核心
            swiperTopbot: {
                direction: "horizontal", // swiper 方向
                mousewheel: true,
                autoplay: { delay: 13000, disableOnInteraction: false },
                // 分页器
                pagination: {
                    el: ".top-pagination", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 同步tab状态
                        if (this.$refs.swiperTop && this.$refs.swiperTop.$swiper) {
                            this.topTabActive = this.$refs.swiperTop.$swiper.activeIndex;
                        }
                    },
                }
            },
        };
    },
    mounted() {
        // 初始化定时器，开始监听
        let that = this
        // 页面需要
        if (that.$route.query.num && that.$route.query.num != 0) {
            this.topTabActive = that.$route.query.num * 1;
            console.log(that.$route.query.num)
            if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                that.$refs.mySwiper.$swiper.slideTo((that.$route.query.num * 1) + 0);
                console.log((that.$route.query.num * 1) + 1);
            }
        } else {
            this.topTabActive = 0;
            if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                that.$refs.mySwiper.$swiper.slideTo(0);
            }
        }

        // 导航栏

    },

    watch: {
        // 监听 businessActive 变量的变化
        businessActive(newVal, oldVal) {
            // 每次 businessActive 变化时，重置15秒的计时器
            clearTimeout(this.timeoutId);
            // this.resetTimeout();

        },
        // 视频切换一直播放
        activeIndex(newVal, oldVal) {
            // console.log(newVal, oldVal,'ppppppp');
            // if (newVal == 5) {
            //     let video = this.$refs.video1;  // 获取视频元素
            //     if (video) {
            //         video.currentTime = 0;  // 将视频播放时间重置为 0
            //         video.play();  // 播放视频
            //     }
            // }
            if (newVal == 5) {
                let video = this.$refs.video2;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }
            // 核心业务
            if (newVal == 4) {
                this.businessActive = 0
            }
        },
        // 页面需要
        '$route.query.num': function (newNum) {
            // 这里是num变化时执行的操作
            let that = this
            if (that.$route.query.num != 0) {
                console.log('num changed:', newNum);
                this.topTabActive = that.$route.query.num * 1;
                console.log(that.$route.query.num)
                if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                    that.$refs.mySwiper.$swiper.slideTo((that.$route.query.num * 1) + 0);
                    console.log((that.$route.query.num * 1) + 1);
                }
            } else {
                console.log('num chassssnged:', newNum);

                this.topTabActive = 0;
                if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                    that.$refs.mySwiper.$swiper.slideTo(0);
                }
            }
        }

    },
    methods: {
        // 切换发展选项卡
        switchDevelopmentTab(index) {
            this.developmentTabActive = index;
        },
        // 切换模块  第一篇和第二篇
        switchModule(index) {
            this.currentModule = index;
            this.isExpanded = false; // 切换模块时收起详细内容
        },
        // 切换查看全部状态
        toggleExpanded() {
            this.isExpanded = !this.isExpanded;
        },
        // 切换展开/收起状态
        toggleExpand(index) {
            this.expandedItem = this.expandedItem === index ? null : index;
            console.log('切换展开状态:', index, this.expandedItem);
        },
        // 选择战略项目
        selectStrategy(index) {
            if (!this.isStrategyExpanded) {
                this.selectedStrategy = this.selectedStrategy === index ? -1 : index;
            }
        },
        switchTab(index) {
            this.businessActive = index;
            this.pageIndex = index;
            // 清除定时器，重置 15 秒的计时
            clearTimeout(this.timeoutId);
            // 重启15秒监控
            // this.resetTimeout();

            // 如果有正在进行的定时器，清除并重新启动自动切换定时器
            clearInterval(this.intervalId);
            this.autoSwitchTab();
        },

        // 轮播图的tab
        switchTopTab(index) {
            console.log(index);
            this.topTabActive = index;
            // 同步轮播图
            if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
                this.$refs.mySwiper.$swiper.slideTo(index + 1);
            }
        },

        // 自动切换 tab
        // autoSwitchTab() {
        //     this.intervalId = setInterval(() => {
        //         // 自动切换到下一个 tab
        //         this.businessActive = (this.businessActive + 1) % this.businessList.length;
        //         this.pageIndex = this.businessActive;
        //     }, 10000); // 每 10 秒切换一次
        // },

        // 监控 businessActive 的变化，如果15秒没有变化则触发 autoSwitchTab
        resetTimeout() {
            this.timeoutId = setTimeout(() => {
                this.autoSwitchTab(); // 如果15秒内没有变化，触发自动切换 tab
            }, 15000); // 15秒没有变化则触发
        },
        topOne() {
            this.$refs.mySwiper.$swiper.slideTo(0);
            this.activeIndex = 0
        },
        // ... 第一篇 第二篇
        switchContentTab(tab) {
            this.currentTab = tab;
            // 可以根据不同tab切换不同的contentItems数据
        },
        // 切换企业荣誉选项卡
        switchHonorTab(tab) {
            this.honorActiveTab = tab;
        },
        // 市场认可轮播控制方法
        nextMarketSlide() {
            // 切换swiperTop到下一页
            if (this.$refs.swiperbotom && this.$refs.swiperbotom.$swiper) {
                this.$refs.swiperbotom.$swiper.slideNext();
            }
            // 如需同步cardPageIndex变量，可保留如下逻辑
            if (this.swiperbotomInex < 1) {
                this.swiperbotomInex++;
            } else {
                this.swiperbotomInex = 0;
            }
            console.log('下一页，当前页:', this.swiperbotomInex);
        },
        prevMarketSlide() {
            if (this.$refs.swiperbotom && this.$refs.swiperbotom.$swiper) {
                this.$refs.swiperbotom.$swiper.slidePrev();
            }
            // 如需同步swiperbotomInex变量，可保留如下逻辑
            if (this.swiperbotomInex > 0) {
                this.swiperbotomInex--;
            } else {
                this.swiperbotomInex = 1;
            }
            console.log('上一页，当前页:', this.swiperbotomInex);
        },
        goToMarketSlide(index) {
            this.marketCurrentSlide = index;
            console.log('跳转到页面:', index);
        },
        // 5个
        jumps(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'IntoZhg', query: { num: a, time: timestamp } })
        },

        jumphx(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'DevelopmentStrategy', query: { num: a, time: timestamp } })
        },

        jumpcj(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'core', query: { num: a, time: timestamp } })
        },
        jumpWebs() {
            window.location.href = 'https://open.gjwec.com/#/'
        },

        jumpgh(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'coop', query: { num: a, time: timestamp } })
        },
        // 跳转智慧码
        jumpZh() {
            window.location.href = 'https://web-aggregation.gjwec.com'
        },
        jumpWebs() {
            window.location.href = 'https://open.gjwec.com/#/'
        },
        //事件
        lookAll(index) {
            this.secondData[index].showAll = !this.secondData[index].showAll;
        },
        // 第二块
        lookAlltwoData(index) {
            this.twoData[index].showAlltwoData = !this.twoData[index].showAlltwoData;
        },
        // 第三块
        lookAlltreen(index) {
            this.treen[index].showAlltreen = !this.treen[index].showAlltreen;
        },
        // 第四块
        lookAllfours(index) {
            this.fours[index].showAllfours = !this.fours[index].showAllfours;
        },
        nextCardPage() {
            // 切换swiperTop到下一页
            if (this.$refs.swiperTwo && this.$refs.swiperTwo.$swiper) {
                this.$refs.swiperTwo.$swiper.slideNext();
            }
            // 如需同步cardPageIndex变量，可保留如下逻辑
            if (this.cardPageIndex < 1) {
                this.cardPageIndex++;
            } else {
                this.cardPageIndex = 0;
            }
            console.log('下一页，当前页:', this.cardPageIndex);
        },
        prevCardPage() {
            // 切换swiperTop到上一页
            if (this.$refs.swiperTwo && this.$refs.swiperTwo.$swiper) {
                this.$refs.swiperTwo.$swiper.slidePrev();
            }
            // 如需同步cardPageIndex变量，可保留如下逻辑
            if (this.cardPageIndex > 0) {
                this.cardPageIndex--;
            } else {
                this.cardPageIndex = 1;
            }
            console.log('上一页，当前页:', this.cardPageIndex);
        },
    },
};
</script>

<style scoped>
/* 上排证书从左向右动画 - 居中对齐 */
.animated-partner-row-delay1 {
    animation: slideInFromRight 0.8s ease-out forwards;
}

.animated-image {
    animation: slideInFromRight 0.8s ease-out forwards;
    transform: translateX(100%);
    opacity: 0;
}

@keyframes slideInFromRight {
    0% {
        transform: translateX(100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

.animated-cert-left {
    animation: slideInFromLeftCert 1.5s ease-out forwards;
    transform: translateX(-100%);
    opacity: 0;
}

.animated-partner-row {
    animation: slideInFromLeft 0.8s ease-out forwards;
}

@keyframes slideInFromLeftCert {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 智谷链 */
.video-containers {
    position: relative;
    height: 100%;
    overflow: hidden;
    padding-top: 10px;
}

.text-overlays {
    position: absolute;
    top: 100px;
    /* left: 50%; */
    transform: translateX(-50%);
    color: #333;
    font-size: 28px;
    font-weight: bold;
}

.subtitle {
    position: absolute;
    top: 150px;
    /* left: 50%; */
    transform: translateX(-50%);
    color: #A7A9AC;
    font-size: 20px;
}

/* 发展选项卡样式 */
.development-tabs {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
}

.tab-qiye {
    margin-top: 10px;
}

.development-tabs .tab-qiye {
    display: flex;
    justify-content: center;
    gap: 20px;
    background: rgba(255, 255, 255, 0.5);
    padding: 15px;
    border-radius: 50px;
    margin-bottom: 5px;
}

.development-tabs .tab-item {
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.3s ease;
    font-size: 16px;
    color: #989898;
}

.development-tabs .tab-item:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #333;
}

.development-tabs .tab-item.active {
    /* background: linear-gradient(90deg, #BFE9FF 0%, #D6E2FF 100%); */
    color: #2c3e50;
    border-radius: 50px;
}

@media (max-width: 768px) {
    .development-tabs {
        margin-bottom: 30px;
    }

    .development-tabs .tab-nav {
        gap: 10px;
        padding: 10px;
    }

    .development-tabs .tab-item {
        font-size: 14px;
        padding: 8px 15px;
    }
}

@media (max-width: 480px) {
    .development-tabs .tab-nav {
        gap: 5px;
        padding: 8px;
    }

    .development-tabs .tab-item {
        font-size: 12px;
        padding: 6px 12px;
    }
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* 顶部轮播图tab导航样式 - 与business-tabs保持一致 */
.top-business-tabs {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
    width: 100%;
    max-width: 1200px;
    display: flex;
    justify-content: center;
}

.top-business-tabs .tab-nav {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 0;
    background: rgba(255, 255, 255, 0.5);
    padding: 15px;
    border-radius: 50px;
}

.top-business-tabs .tab-item {
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.3s ease;
    font-size: 16px;
    color: #2c3e50;
}

.top-business-tabs .tab-item:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #333;
}

.top-business-tabs .tab-item.active {
    background: linear-gradient(90deg, #BFE9FF 0%, #D6E2FF 100%);
    color: #2D7CFE;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.01);
    border-radius: 50px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .top-business-tabs {
        bottom: 80px;
        padding: 0 20px;
    }

    .top-business-tabs .tab-nav {
        flex-wrap: wrap;
        gap: 10px;
        padding: 10px;
    }

    .top-business-tabs .tab-item {
        font-size: 14px;
        padding: 8px 15px;
    }
}

@media (max-width: 480px) {
    .top-business-tabs .tab-nav {
        gap: 5px;
        padding: 8px;
    }

    .top-business-tabs .tab-item {
        font-size: 12px;
        padding: 6px 12px;
    }

    .strategy-container {
        padding: 0 10px;
    }

    .strategy-row {
        gap: 10px;
    }

    .strategy-item {
        min-height: 220px;
    }

    .strategy-item.expanded {
        min-height: 300px;
    }

    .strategy-icon {
        width: 50px;
        height: 50px;
    }

    .strategy-icon img {
        width: 30px;
        height: 30px;
    }

    .strategy-title {
        font-size: 14px;

    }

    .strategy-subtitle {
        font-size: 10px;
    }

    .strategy-content {
        font-size: 11px;
        padding: 5px;
        min-height: 60px;
    }

    .expand-icon {
        bottom: 5px;
    }

    .expand-icon img {
        width: 20px;
        height: 20px;
    }
}

/* 顶部按钮*/
.top-nav {
    width: 40px;
    height: 40px;
    position: fixed;
    right: 0em;
    bottom: 560px;
    z-index: 1000;
    cursor: pointer;
    transition: all 0.3s ease;
}

.top-nav:hover {
    transform: scale(1.1);
}

#mySwiper {
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.swiper-pagination {
    right: 1em;
}

/* 四个轮播 */
/* 配置分页器的颜色 */
#swiperTop {
    --swiper-pagination-color: #fff;
    /* 未选中状态颜色为白色 */
    --swiper-pagination-current-color: #0000ff;
    /* 选中状态颜色为蓝色 */
}

#swiperTwo {
    height: 600px;
    --swiper-pagination-color: #2D7CFE;
    /* 未选中状态颜色为白色 */
    --swiper-pagination-current-color: #0000ff;
    /* 选中状态颜色为蓝色 */
}

/* 如果想要分页器小圆点的大小和样式进行微调 */
.swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.swiper-pagination-bullet-active {
    background-color: #0000ff;
    /* 选中的小圆点颜色为蓝色 */
}

.top-pagination,
.two-pagination,
.swiperbotom {
    position: absolute;
    width: 100%;
    justify-content: center;
    bottom: 10px;
    display: flex !important;
    z-index: 15;
}

.top-pagination .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #ccc;
    opacity: 1;
    transition: background 0.3s;
}

.two-pagination .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    margin: 0 5px;
    background: #555;
    /* 未选中时为灰色 */
    opacity: 1;
    transition: all 0.3s ease;
}

.top-pagination .swiper-pagination-bullet-active {
    background: #2D7CFE;
    /* 选中时为蓝色 */
}

.two-pagination .swiper-pagination-bullet-active {
    background: #2D7CFE;
    /* 选中时为蓝色 */
}

/* 1111111111智慧谷官网 */
.insta {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.insta-Tit {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    font-size: 33px;
    font-weight: bold;
    color: #333;
}

.insta-subtitle {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    font-size: 18px;
    color: #A7A9AC;
}

.font-con {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    width: 80%;
    text-align: left;
    text-indent: 2em;
    line-height: 2;
}

.redice {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    box-sizing: border-box;
    margin-top: 30px;
}

.rediceItem {
    border: 1px solid #2D7CFE;
    border-radius: 20px;
    width: 43%;
    overflow: hidden;
    min-height: 480px;
    position: relative;
}

.rediceItem-title {
    width: 100%;
    height: 100px;
    background-image: url('https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/962.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 10px;
    padding-left: 30px;
    padding-right: 30px;
}

.rediceItem-title-Top {
    font-size: 20px;
    color: #fff;
}

.rediceItem-title-Bottom {
    padding-top: 5px;
    font-size: 15px;
    color: #fff;
}

.rediceItem-content {
    padding-left: 30px;
    padding-right: 10px;
}

.rediceItem-content-title {
    font-size: 18px;
    font-weight: 600;
    padding-bottom: 5px;
}

.rediceItem-content-notice {
    font-size: 16px;
    color: #8A99A7;
    display: flex;
    align-items: center;
    padding-bottom: 5px;
}

.rediceItem-content-round {
    font-size: 7px;
    color: #2D7CFE;
    margin-right: 10px;
}

/* 左右按钮四块内容 */
/* 容器样式 */
/* Container for the content */
.backCon {
    display: flex;
    justify-content: center;
    padding: 20px;
    width: 100%;
}

.cardTwo {
    display: flex;
    position: relative;
    justify-content: space-between;
    width: 75%;
}

.left-button,
.right-button {
    position: absolute;
    top: 50%;
    transform: translateY(-40%);
    cursor: pointer;
}

.left-button {
    left: -4%;
}

.left-button img {
    width: 40px;
    height: 40px;
}

.right-button {
    right: -4%;

}

.right-button img {
    width: 40px;
    height: 40px;
}

.card-header {
    background-image: url('../assets/jt1.png');
    background-size: cover;
    padding: 20px;
    border-radius: 10px;
    color: #fff;
    text-align: center;
}

.card-titles {
    font-size: 20px;
    font-weight: bold;
    display: flex;
    padding-left: 10px;
    padding-right: 10px;
}

.card-subtitles {
    font-size: 14px;
    display: flex;
    margin-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
}

.card-content {
    border-radius: 0 0 10px 10px;
    /* 只保留底部圆角 */
    margin-top: 0;
    /* 移除负边距，确保与头部对齐 */
}

.card-content ul li::marker {
    color: #2D7CFE;
    height: 30px;
}

.content-item h4 {
    font-size: 18px;
    color: #333;
    margin-bottom: 10px;
}

.content-item ul {
    padding-left: 20px;
    list-style-type: disc;
}

.content-item ul li {
    font-size: 14px;
    color: #555;
    height: 30px;
}

/* 第一个轮播图视频 */
.textara {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #fff;
    width: 100%;
    top: 280px;
}


.text-cons {
    font-size: 75px;
    padding-bottom: 5px;
}

.text-fonts {
    font-size: 20px;
}

.one-card,
.two-card {
    width: 300px;
    border-radius: 20px;
    background-color: #fff;
    overflow: hidden;
    display: flex;
    /* 使用弹性布局 */
    flex-direction: column;
}

.one-card .card-header,
.two-card .card-header {
    border-radius: 10px 10px 0 0;
    flex-shrink: 0;
}

.one-card .card-content,
.two-card .card-content {
    flex: 1;
    /* 内容区域占据剩余空间 */
    border: 1px solid #2D7CFE;
    border-top: none;
}

/* Responsiveness */
@media (max-width: 768px) {
    .cardTwo {
        flex-direction: column;
    }

    .left-button,
    .right-button {
        left: 0;
        right: 0;
        top: auto;
        transform: none;
    }

    .one-card,
    .two-card {
        width: 100%;
        margin-bottom: 20px;
    }
}

/* 视频容器样式优化 */
.video-center {
    position: relative;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.video-center video {
    width: 80vw;
    height: 70vh;
    object-fit: cover;
    margin-top: 140px;
}

.video-center>div {
    position: absolute;
    top: -34%;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    text-align: center;
}

.text-over {
    color: #333;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
}

.subtit {
    color: #A7A9AC;
    font-size: 18px;
    text-align: center;
}

/* 发展历程 */
/* .big-one {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 100px;
}

.time-round {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 300px;
}

.time-text {
    color: #333;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
}

.big-round {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;
}

.time-top {
    position: absolute;
    top: 130px;
    width: 100%;
    height: 300px;
    left: 220px;
}

.time-item {
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: space-around;
} */

/* big-time 样式 */

.big-one {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 90px;
}


.time-text {
    color: #333;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
}

.big-time {
    position: relative;
    margin-top: 340px;
}

.time-con {
    position: relative;
}

.big-round {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;
}

.round-img {
    width: 150px;
    position: absolute;
    left: -100px;
    z-index: 2;
    transform: scale(0);
    transform-origin: center;

}

.round-ones {
    animation: roundGrow 0.8s ease-out forwards;
}

@keyframes roundGrow {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

.axis-img {
    width: 1200px;
    display: block;
    transform: scaleX(0);
    transform-origin: left center;

}

.axis-ones {
    animation: axisGrow 0.8s ease-out forwards;
}

@keyframes axisGrow {
    0% {
        transform: scaleX(0);
    }

    100% {
        transform: scaleX(1);
    }
}


/* 公共节点容器 */
.time-top,
.time-bottom {
    position: absolute;
    left: 50px;
    width: 100%;
    display: flex;
    justify-content: center;
}

.time-top {
    top: 20px;
    left: 100px;
}

.time-bottom {
    bottom: 20px;
}

/* 节点列表 */
.time-item {
    width: 70%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.time-item img {
    width: 23%;
    height: 280px;
    opacity: 0;
    transform: scale(0.5);
    animation-fill-mode: forwards;
    animation-duration: 0.8s;
    animation-timing-function: ease-out;
}



.fade-in-1 {
    animation-name: fadeInImage;
    animation-delay: 0.2s;
    animation-play-state: running;
}

.fade-in-2 {
    animation-name: fadeInImage;
    animation-delay: 0.6s;
    animation-play-state: running;
}

.fade-in-3 {
    animation-name: fadeInImage;
    animation-delay: 1s;
    animation-play-state: running;
}

.fade-in-4 {
    animation-name: fadeInImage;
    animation-delay: 1.4s;
    animation-play-state: running;
}

@keyframes fadeInImage {
    from {
        opacity: 0;
        transform: scale(0.5);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

/* 专家团队 */
.zhuan-con {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-top: 50px;
}

/* 标题 */
.insta-Tits {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    font-size: 33px;
    font-weight: bold;
    color: #333;
}

.insta-subtitles {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    font-size: 18px;
    color: #A7A9AC;
}

.item-six {
    display: flex;
    width: 70%;
    align-items: center;
    justify-content: space-around;
    margin-top: 50px;
    padding-bottom: 40px;
}

.item-contan {
    width: 26%;
    height: 260px;
    border: 1px dashed #0cd5fd;
    position: relative;
    padding: 10px;
    border-radius: 5px;
    background: linear-gradient(180deg, #FFFFFF 0%, #E2F3FC 100%);
    padding-top: 20px;
    padding-bottom: 20px;
    line-height: 1.5em;
}

.item-contan ul li {
    font-size: 15px;
    color: #333;
    line-height: 1.6;
    margin-bottom: 8px;
}

.item-contan ul li::marker {
    color: #2D7CFE;
    /* 蓝色圆圈 */
}

.item-contans {
    width: 26%;
    height: 260px;
    border: 1px dashed #0cd5fd;
    position: relative;
    padding: 10px;
    border-radius: 5px;
    background: linear-gradient(180deg, #FFFFFF 0%, #E2F3FC 100%);
    padding-top: 20px;
    padding-bottom: 20px;
    line-height: 1.5em;
}

.item-contans ul li {
    font-size: 15px;
    color: #333;
    line-height: 1.6;
    margin-bottom: 8px;
}

.item-contans ul li::marker {
    color: #00D3FD;
    /* 蓝色圆圈 */
}

/* 新的专家团队布局样式 */
.expert-container {
    display: flex;
    width: 80%;
    max-width: 1200px;
    margin: 50px auto 40px auto;
    justify-content: center;
    align-items: flex-start;
    gap: 30px;
}

.left-experts {
    flex: 3;
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.expert-row {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    /* border: 1px solid; */
    margin-left: 20px;

}

.expert-row .item-contan {
    width: calc(48% - 10px);
    height: 280px;
    /* border: 1px solid; */
}


.right-expert {
    flex: 1;
    display: flex;
    justify-content: center;
}

.item-contan-larges {
    width: 100%;
    height: 600px;
    /* 两个普通卡片的高度加上间距 */
    border: 1px dashed #2D7CFE;
    position: relative;
    padding: 10px;
    border-radius: 5px;
    background: linear-gradient(180deg, #FFFFFF 0%, #EAF1FF 100%);
    padding-top: 20px;
    padding-bottom: 20px;
    line-height: 1.5em;
}

.item-contan-larges ul li {
    font-size: 15px;
    color: #333;
    line-height: 1.6;
    margin-bottom: 8px;
}

.item-contan-larges ul li::marker {
    color: #2D7CFE;
    /* 蓝色圆圈 */
}

.footer_botm {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    font-size: 16px;
}

.code {
    position: absolute;
    right: 18%;
    top: 0;
    width: 35%;
    align-items: center;
    justify-content: space-around;
    display: flex;
}

.footerTopRight {
    height: 240px;
    font-size: 14px;
    position: relative;
    left: 3%;
    width: 40%;
}

.RightCon {
    height: 18%;
    display: flex;
    align-items: center;
}

.RightCon img {
    width: 25px;
    height: 25px;
    margin-right: 15px;
}

.RightCon p {
    color: #000;
    margin: 0;
    line-height: 25px;
}

.footerTopLeft {
    width: 50%;
    height: 210px;
    display: flex;
    justify-content: space-around;
    /* border: 1px solid; */
    margin-top: 20px;
}

.LeftCon p {
    font-size: 27rpx;
    text-align: center;
    color: #989898;
    cursor: pointer;
    line-height: 2.5;
}

.LeftCon h4 {
    color: #000;
    text-align: center;
    cursor: pointer;
    font-size: 18px;
}

/* 底部导航栏 */
.footer {
    width: 100%;
    height: 340px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    color: #000;
    position: absolute;
    bottom: 0;
}

.footer_top {
    width: 100%;
    height: 300px;
    border-bottom: 1px solid #fff;
    display: flex;
    justify-content: center;
    padding-top: 30px;

}

.gradient-con {
    position: absolute;
    margin-top: -380px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.gradient-text {
    font-size: 70px;
    /* 设置字体大小 */
    font-weight: bold;
    /* 可选的加粗 */
    background: linear-gradient(90deg, #30EDFC 0%, #304EFC 100%);
    -webkit-background-clip: text;
    /* Safari和Chrome支持 */
    background-clip: text;
    /* 适用于Firefox */
    color: transparent;
    /* 使文字透明，从而显示背景渐变 */
    padding-bottom: 30px;
}

.gradient-p {
    font-size: 40px;
    /* 设置字体大小 */
    font-weight: bold;
    color: #fff;
}

.card-img .vjs-custom-skin {
    width: 100%;
    max-width: 580px;
    height: 500px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    /* border: 1px solid red; */
}

.card-img .vjs-custom-skin video {
    object-fit: cover;
}

.animated-image {
    animation: slideInFromRight 1s ease-out forwards;
    transform: translateX(100%);
    opacity: 0;
}

.item-contan-large {
    width: 100%;
    height: 540px;
    /* 两个普通卡片的高度加上间距 */
    border: 1px dashed #0cd5fd;
    position: relative;
    padding: 10px;
    border-radius: 5px;
    background: linear-gradient(180deg, #FFFFFF 0%, #E2F3FC 100%);
    padding-top: 20px;
    padding-bottom: 20px;
    line-height: 1.5em;
}

.item-contan-large ul li {
    font-size: 15px;
    color: #333;
    line-height: 1.6;
    margin-bottom: 8px;
}

.item-contan-large ul li::marker {
    color: #2D7CFE;
    /* 蓝色圆圈 */
}

.item-contan:first-of-type ul li::marker {
    color: #0cd5fd;
}


/* 响应式设计 */
@media (max-width: 1200px) {
    .expert-container {
        width: 95%;
    }
}

@media (max-width: 768px) {
    .expert-container {
        flex-direction: column;
        width: 100%;
        gap: 15px;
    }

    .left-experts {
        flex: none;
    }

    .expert-row {
        flex-direction: column;
        gap: 15px;
    }

    .expert-row .item-contan {
        width: 100%;
    }

    .right-expert {
        flex: none;
    }

    .item-contan-large {
        height: 260px;
        /* 在小屏幕上使用正常高度 */
    }
}


/* 3333333333333333第一篇、第二篇  */
.one-card {
    width: 100%;
    height: 100%;
    padding: 0 5%;
    box-sizing: border-box;
    padding-top: 50px;
}

.gradient-btn {
    width: 280px;
    margin-top: 50px;
    height: 60px;
    padding: 10px 30px;
    border: none;
    border-radius: 50px;
    background: linear-gradient(90deg, #2821FE 0%, #00D4FF 100%);
    color: white;
    font-size: 28px;
    cursor: pointer;
    transition: transform 0.3s ease;
}

.gradient-btn:hover {
    transform: scale(1.05);
}

/* 业务内容区域样式 */
.business-content-section {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
}

/* Tab导航样式 */
.tab-navs {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-bottom: 20px;
    background: transparent;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #E5E5E5;
}

.tab-item {
    padding: 15px 0;
    cursor: pointer;
    border-radius: 0;
    transition: all 0.3s ease;
    font-size: 16px;
    color: #9EAAC1;
    font-weight: 400;
    position: relative;
    background: transparent;
    border-bottom: 2px solid transparent;
}

.tab-item:hover {
    color: #2D7CFE;
}

/* .tab-item.active {
    color: #2D7CFE;
    border-bottom: 2px solid #2D7CFE;
    font-weight: 500;
} */

/* 3333333内容网格样式 */
.content-grid {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 0;
}

.grid-row {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    flex-wrap: wrap;
}

.grid-item {
    background: #EEF3FF;
    border-radius: 12px;
    padding: 20px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: flex-start;
    gap: 15px;
    justify-content: space-between;
    width: 32%;
    border: 1px solid;
}

.item-icon {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.item-icon img {
    width: 32px;
    height: 32px;
    object-fit: contain;
}

.item-content {
    flex: 1;
}

.item-content h4 {
    color: #2D7CFE;
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 8px 0;
    line-height: 1.4;
}

.item-content p {
    color: #333;
    font-size: 14px;
    margin: 0;
    line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 1024px) {
    .grid-row {
        flex-direction: column;
        gap: 15px;
    }

    .grid-item {
        width: 100%;
    }
}

@media (max-width: 768px) {
    .grid-item {
        width: 100%;
        padding: 15px;
    }

    .item-icon {
        width: 40px;
        height: 40px;
    }

    .item-icon img {
        width: 28px;
        height: 28px;
    }

    .item-content h4 {
        font-size: 15px;
    }

    .item-content p {
        font-size: 13px;
    }
}


/* 标题动画 - 从左侧滑入居中 */
.card-Tit {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    font-size: 33px;
    font-weight: bold;
    color: #333;
}

.card-con {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    font-size: 22px;
    color: #A7A9AC;
}

.animated-title {
    animation: slideInFromLeft 2s ease-out forwards;
    transform: translateX(-100%);
}

@keyframes slideInFromLeft {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 创始人寄语 */
/* 创始人寄语 */
.jy-card {
    width: 100%;
    height: 100%;
    padding: 0 5%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.founder-message-card {
    width: 100%;
    height: auto;
    /* 根据内容的高度自适应 */
    max-width: 1200px;
    background-image: url('../assets/jy.png');
    margin-top: 30px;
    position: relative;
    background-size: contain;
    /* 让背景图完整显示 */
    background-position: center;
    background-repeat: no-repeat;
    z-index: 9999;
    padding-left: 40px;
    padding-right: 40px;
}

.card-header-section {
    padding: 30px;
    text-align: center;
    position: relative;
}

.card-header-section::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: contain;
    /* 同样的调整背景图显示 */
    opacity: 0.1;
}

.main-title {
    color: #333;
    font-size: 21px;
    margin: 0;
    position: relative;
    z-index: 2;
    top: 60px;
}

.card-content-section {
    padding: 40px;
    position: relative;
}

.founder-info {
    display: flex;
    gap: 40px;
    align-items: flex-start;
}

.founder-avatar {
    flex-shrink: 0;
    position: relative;
}

.founder-avatar img {
    width: 250px;
    height: 450px;
    object-fit: cover;
    /* border-radius: 10px; */
}

.founder-message {
    flex: 1;
    padding-left: 20px;
}

.message-content {
    line-height: 1.8;
    color: #333;
}

.intro-text {
    font-size: 16px;
    margin-bottom: 25px;
    text-align: justify;
    line-height: 1.8;
    text-indent: 2em;
    position: relative;
    top: 20px;
}

.message-highlights {
    margin-top: 20px;
}

.highlight-item {
    padding: 15px;
    margin-bottom: 20px;
    font-size: 15px;
    line-height: 1.6;
    text-indent: 2em;
    position: relative;
    top: 20px;
}

.business-goals {
    margin: 20px 0;
    padding-left: 20px;
    position: relative;
    top: 20px;
}

.business-goals p {
    margin: 8px 0;
    font-size: 15px;
    color: #555;
    position: relative;
}

.business-goals p::before {
    font-weight: bold;
    position: absolute;
    left: -15px;
}

.signature {
    margin-top: 30px;
    text-align: right;
    /* 签名右对齐 */
    padding-top: 20px;
    display: flex;
    justify-content: flex-end;
    /* 内容右对齐 */
    width: 100%;
    /* 保证宽度满，确保对齐 */
}

.signature-text {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
}

.signature-text img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.animated-title {
    animation: slideInFromLeft 2s ease-out forwards;
    transform: translateX(-100%);
}

@keyframes slideInFromLeft {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

.animated-title-second {
    animation: slideInFromLeft 0.8s ease-out forwards;
    transform: translateX(-100%);
    opacity: 0;
}

/* 下排证书整体从右向左动画 */
.animated-bottom-row {
    animation: slideInFromRightRow 2.5s ease-out forwards;
    transform: translateX(100%);
    opacity: 0;
}

@keyframes slideInFromRightRow {
    0% {
        transform: translateX(100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 响应式设计 */
@media (max-width: 768px) {
    .founder-info {
        flex-direction: column;
        gap: 20px;
        align-items: center;
    }

    .founder-avatar {
        align-self: center;
    }

    .founder-avatar img {
        width: 150px;
        height: 180px;
    }

    .founder-message {
        padding-left: 0;
    }

    .main-title {
        font-size: 22px;
    }

    .card-content-section {
        padding: 20px;
        padding-top: 40px;
    }

    .intro-text {
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .jy-card {
        padding: 0 3%;
    }

    .founder-message-card {
        margin-top: 20px;
    }

    .card-header-section {
        padding: 20px;
    }

    .main-title {
        font-size: 20px;
    }
}

.card-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    width: 100%;
}

.card {
    display: flex;
    width: 30%;
    flex-direction: column;
    border-radius: 10px;
    background: #eef3ff;
    padding: 20px;
    align-items: flex-start;
    opacity: 0;
    animation: slideInLeft 1s ease-out forwards;
}

/* 标题 */
.qiye-Tits {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    font-size: 33px;
    font-weight: bold;
    color: #333;
}

.qiye-subtitles {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    font-size: 18px;
    color: #A7A9AC;
}


/* 企业文化 development-tabs 选项卡样式优化 */
.cont-qiye {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.contq-Tit {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    font-size: 33px;
    font-weight: bold;
    color: #333;
}

.contq-sub {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    font-size: 18px;
    color: #A7A9AC;
}

/* 文字 */
.f-14 {
    font-size: 14px;
    line-height: 1.8em;
}

.development-tabs {
    width: 100%;
    margin: 0 auto 32px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.development-tabs .tab-nav {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 48px;
    width: 100%;
    border-bottom: 1.5px solid #e5eaf3;
    margin-bottom: 24px;
    background: transparent;
}

.development-tabs .tab-item {
    font-size: 20px;
    color: #9EAAC1;
    padding: 0 24px 12px 24px;
    background: transparent;
    border: none;
    border-radius: 0;
    cursor: pointer;
    position: relative;
    transition: color 0.3s, font-weight 0.3s;
}

.development-tabs .tab-item.active {
    color: #2D7CFE;
}

.development-tabs .tab-item.active::after {
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    bottom: -2px;
    transform: translateX(-50%);
    width: 48px;
    height: 3px;
    background: linear-gradient(90deg, #2D7CFE 0%, #00D4FF 100%);
    border-radius: 2px;
}

.development-tabs .tab-item:hover {
    color: #2D7CFE;
}

@media (max-width: 768px) {
    .development-tabs .tab-nav {
        gap: 24px;
    }

    .development-tabs .tab-item {
        font-size: 16px;
        padding: 0 12px 10px 12px;
    }

    .development-tabs .tab-item.active::after {
        width: 32px;
        height: 2px;
    }
}

@media (max-width: 480px) {
    .development-tabs .tab-nav {
        gap: 12px;
    }

    .development-tabs .tab-item {
        font-size: 14px;
        padding: 0 6px 8px 6px;
    }

    .development-tabs .tab-item.active::after {
        width: 20px;
        height: 2px;
    }
}

/* 发展战略样式 */
.fazhan {
    width: 100%;
    height: 100%;
    padding: 0 5%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.fazhan-Tit {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    font-size: 33px;
    font-weight: bold;
    color: #333;
}

.fazhan-subtitle {
    font-size: 18px;
    color: #888;
    margin-top: 10px;
    margin-bottom: 40px;
    text-align: center;
}

.strategy-container {
    width: 100%;
    max-width: 1200px;
}

.strategy-container.expanded {
    min-height: 600px;
}

.strategy-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
    gap: 20px;
    margin-top: 20px;
}

.strategy-item {
    flex: 1;
    background: #EEF3FF;
    border-radius: 15px;
    text-align: center;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 10px;
    padding-bottom: 10px;
    height: 260px;
    transition: all 0.3s ease;
    width: 260px;
    /* overflow: hidden; */
}

/* 折叠出现 */
.strategy-item.expanded {
    min-height: 335px;
    background: #F5F8FF;
}

.strategy-icon {
    width: 60px;
    height: 60px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
}

.strategy-icon img {
    width: 40px;
    height: 40px;
}

.strategy-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 3px;
    color: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
}

.strategy-subtitle {
    font-size: 14px;
    opacity: 0.8;
    line-height: 1.5;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 5px;
    width: 100%;
    text-align: center;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 5;
    max-height: calc(1.5em * 5);
}

.strategy-content {
    width: 100%;
    font-size: 14px;
    line-height: 1.5;
    opacity: 0;
    text-align: center;
    /* overflow: hidden; */
    padding-left: 20px;
    padding-right: 20px;
    max-height: 0;
    transition: all 0.3s ease;
    transform: translateY(20px);
}

.strategy-item.expanded .strategy-content {
    max-height: 200px;
    opacity: 1;
    transform: translateY(0);
}

.strategy-content p {
    margin: 0;
    text-align: center;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 5;
    max-height: calc(1.5em * 5);
}

.expand-icon {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    transition: all 0.3s ease;
    opacity: 0.7;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.expand-icon:hover {
    opacity: 1;
    transform: translateX(-50%) translateY(-2px);
}

.expand-icon img {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.6;
}

/* 动画效果 */
.animated-cert-left {
    animation: slideInFromLeftCert 1.5s ease-out forwards;
    transform: translateX(-100%);
    opacity: 0;
}

.animated-bottom-row {
    animation: slideInFromLeftCert 1.5s ease-out 0.3s forwards;
    transform: translateX(-100%);
    opacity: 0;
}

@keyframes slideInFromLeftCert {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 响应式设计 - 移动端优化 */
@media (max-width: 768px) {
    .strategy-content {
        font-size: 12px;
        line-height: 1.4;
        padding: 8px 0;
        min-height: 60px;
        /* 移动端较小的最小高度 */
    }

    .strategy-content p {
        font-size: 12px;
    }
}

@media (max-width: 480px) {
    .strategy-content {
        font-size: 11px;
        line-height: 1.3;
        padding: 6px 0;
        min-height: 50px;
        /* 小屏幕更小的最小高度 */
    }

    .strategy-content p {
        font-size: 11px;
    }
}

/* 企业文化模块样式 */
.development-content {
    width: 80%;
    margin: 30px auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.development-row {
    display: flex;
    justify-content: space-between;
    gap: 20px;
}

.development-item {
    flex: 1;
    background: #F8FAFF;
    border-radius: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.3s ease;
    cursor: pointer;
}

.development-item:hover {
    background: #F5F8FF;
    transform: translateY(-5px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.item-icon {
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, #E8F0FF 0%, #F5F8FF 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
    margin-bottom: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease;
}

.development-item:hover .item-icon {
    transform: scale(1.05);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.item-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.item-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
    transition: color 0.3s ease;
}

.development-item:hover .item-title {
    color: #2D7CFE;
}

.item-subtitle {
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;
    position: relative;
    padding-bottom: 12px;
}

.item-subtitle::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
    height: 2px;
    background: linear-gradient(90deg, #3BACFB 0%, #2D7CFE 100%);
    border-radius: 1px;
}

.item-content {
    font-size: 14px;
    color: #666;
    text-align: center;
    line-height: 1.6;
    margin-top: auto;
    padding: 0 10px;
}

@media (max-width: 768px) {
    .development-content {
        width: 90%;
        gap: 15px;
    }

    .development-row {
        flex-direction: column;
        gap: 15px;
    }

    .development-item {
        padding: 15px;
        min-height: auto;
    }

    .item-icon {
        width: 50px;
        height: 50px;
        padding: 12px;
        margin-bottom: 12px;
    }

    .item-title {
        font-size: 16px;
        margin-bottom: 6px;
    }

    .item-subtitle {
        font-size: 13px;
        margin-bottom: 10px;
        padding-bottom: 10px;
    }

    .item-subtitle::after {
        width: 25px;
    }

    .item-content {
        font-size: 13px;
        padding: 0 8px;
    }
}

@media (max-width: 480px) {
    .development-content {
        width: 95%;
        gap: 12px;
    }

    .development-row {
        gap: 12px;
    }

    .development-item {
        padding: 12px;
    }

    .development-item:hover {
        transform: translateY(-3px);
    }

    .item-icon {
        width: 40px;
        height: 40px;
        padding: 10px;
        margin-bottom: 10px;
    }

    .item-title {
        font-size: 15px;
        margin-bottom: 5px;
    }

    .item-subtitle {
        font-size: 12px;
        margin-bottom: 8px;
        padding-bottom: 8px;
    }

    .item-subtitle::after {
        width: 20px;
    }

    .item-content {
        font-size: 12px;
        padding: 0 5px;
    }
}

/* 企业荣誉选项卡样式 */
.enterprise-honor-tabs {
    width: 100%;
    margin: 0 auto 40px auto;
    margin-top: 50px;
    height: 100vh;
}

.honor-tabs-container {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
}

.honor-tab-wrapper {
    position: relative;
    margin-right: -20px;
    z-index: 1;
}

.honor-tab-wrapper:last-child {
    margin-right: 0;
}

.honor-tab-wrapper:nth-child(1) {
    z-index: 3;
}

.honor-tab-wrapper:nth-child(2) {
    z-index: 2;
}

.honor-tab-wrapper:nth-child(3) {
    z-index: 1;
}

.honor-tab {
    padding: 15px 40px;
    text-align: center;
    cursor: pointer;
    font-size: 17px;
    /* font-weight: 600; */
    color: #666;
    background: linear-gradient(96deg, #BFE9FF 0%, #D6E2FF 100%);
    clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 100%, 20px 100%);
    position: relative;
    min-width: 350px;
}

.honor-tab span {
    position: relative;
    z-index: 2;
}

.honor-tab.active {
    background: #2D7CFE;
    color: #ffffff;
    box-shadow: 0 6px 20px rgba(45, 124, 254, 0.3);
    z-index: 10;
}

.honor-content {
    min-height: 300px;
    padding: 30px;
    background-image: url('../assets/qyry.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100vw;
    height: 73vh;
}

.honor-panel {
    animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.honor-description {
    text-align: center;
    font-size: 16px;
    color: #666;
    line-height: 1.6;
    margin-bottom: 50px;
}


/* 国家认证样式 */
.certificates-grid {
    display: flex;
    justify-content: center;
    gap: 40px;
    flex-wrap: wrap;
}

.certificate-item {
    text-align: center;
    transition: transform 0.3s ease;
}

.certificate-item:hover {
    transform: translateY(-5px);
}

/* 新增：证书图片容器样式 */
.certificate-image-container {
    position: relative;
    width: 250px;
    height: 180px;
    margin-bottom: 15px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.certificate-image-container:hover {
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    transform: scale(1.02);
}

.certificate-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
}

.certificate-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.certificate-image-container:hover .certificate-overlay {
    opacity: 1;
}

.certificate-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 8px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.certificate-subtitle {
    font-size: 14px;
    opacity: 0.9;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

/* 保留原有的占位符样式以备后用 */
.certificate-placeholder {
    width: 200px;
    height: 150px;
    background: linear-gradient(135deg, #f8f9ff 0%, #e8f2ff 100%);
    border: 2px dashed #4A90E2;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
    transition: all 0.3s ease;
}

.certificate-placeholder:hover {
    background: linear-gradient(135deg, #e8f2ff 0%, #d6e8ff 100%);
    border-color: #2D7CFE;
}

.certificate-icon {
    font-size: 48px;
    margin-bottom: 10px;
}

.certificate-placeholder h4 {
    font-size: 14px;
    color: #4A90E2;
    font-weight: 600;
    margin: 0;
    text-align: center;
    line-height: 1.3;
}

.certificate-label {
    background: linear-gradient(135deg, #4A90E2 0%, #7BB3F0 100%);
    color: #ffffff;
    padding: 8px 16px;
    border-radius: 20px;
    display: inline-block;
}

.label-title {
    font-size: 14px;
    font-weight: 600;
    margin-right: 5px;
}

.label-subtitle {
    font-size: 12px;
    opacity: 0.9;
}

/* 技术创新样式 */
.innovation-content {
    display: flex;
    justify-content: center;
    gap: 40px;
    flex-wrap: wrap;
}

.innovation-item {
    background: linear-gradient(135deg, #f8f9ff 0%, #e8f2ff 100%);
    border: 1px solid #E8F2FF;
    border-radius: 12px;
    padding: 25px;
    text-align: center;
    width: 250px;
    transition: all 0.3s ease;
}

.innovation-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(74, 144, 226, 0.15);
}

.innovation-icon {
    font-size: 36px;
    margin-bottom: 15px;
}

.innovation-item h4 {
    font-size: 18px;
    color: #4A90E2;
    margin-bottom: 10px;
    font-weight: 600;
}

.innovation-item p {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
}



#swiperbotom {
    width: 100%;
    --swiper-pagination-color: #2D7CFE;
    /* 未选中状态颜色为白色 */
    --swiper-pagination-current-color: #0000ff;
    /* 选中状态颜色为蓝色 */
}

.swiperbotom .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #ccc;
    opacity: 1;
    transition: background 0.3s;
}

.swiperbotom .swiper-pagination-bullet-active {
    background: #2D7CFE;
    /* 选中时为蓝色 */
}

.swiperbotom {
    height: 10px;
    display: flex;
    justify-content: center;
}

/* 市场认可轮播容器样式 */
.market-carousel-wrapper {
    /* 新增 */
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    margin-top: -20px;
}

/* 轮播导航按钮样式 */
.carousel-nav-btn {
    position: absolute;
    top: 60%;
    transform: translateY(-60%);
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
}

.carousel-nav-btn img {
    width: 40px;
    height: 40px;
    transition: filter 0.3s ease;
}


.left-buttons,
.right-buttons {
    position: absolute;
    top: 60%;
    transform: translateY(-60%);
    cursor: pointer;
}


.left-buttons img {
    width: 40px;
    height: 40px;
}

.right-buttons {
    right: 10px;
}

.right-buttons img {
    width: 40px;
    height: 40px;
}


.left-buttons {
    left: 0px;
}

.right-buttons {
    right: 0px;
}

/* 市场认可图片容器样式 */
.market-images-container {
    flex-wrap: nowrap;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 500px;
}

.market-image-item {
    width: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
}


.market-image-item img {
    width: 100%;
    height: auto;
    border-radius: 10px;
    transition: all 0.3s ease;
}


/* 轮播指示器样式 */
.market-carousel-indicators {
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
    z-index: 10;
}

.indicator-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #ccc;
    cursor: pointer;
    transition: all 0.3s ease;
}

.indicator-dot:hover {
    background-color: #2D7CFE;
}

.indicator-dot.active {
    /* width: 24px; */
    border-radius: 4px;
    background-color: #2D7CFE;

}


/* 市场认可样式 */
.market-content {
    display: flex;
    justify-content: center;
    gap: 40px;
    flex-wrap: wrap;
}

.market-item {
    background: linear-gradient(135deg, #fff8f0 0%, #ffe8d6 100%);
    border: 1px solid #FFE8D6;
    border-radius: 12px;
    padding: 25px;
    text-align: center;
    width: 250px;
    transition: all 0.3s ease;
}

.market-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(255, 165, 0, 0.15);
}

.market-icon {
    font-size: 36px;
    margin-bottom: 15px;
}

.market-item h4 {
    font-size: 18px;
    color: #FF8C00;
    margin-bottom: 10px;
    font-weight: 600;
}

.market-item p {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
}

/* 响应式设计 */
@media (max-width: 1024px) {
    .honor-tabs-container {
        max-width: 600px;
    }

    .honor-tab-wrapper {
        margin-right: -15px;
    }

    .honor-tab {
        padding: 12px 30px;
        font-size: 15px;
        min-width: 120px;
    }

    .certificates-grid,
    .innovation-content,
    .market-content,
    .market-images-container {
        gap: 20px;
    }

    .market-carousel-wrapper {
        padding: 20px 15px;
    }

    .carousel-nav-btn {
        width: 40px;
        height: 40px;
    }

    .carousel-nav-btn img {
        width: 20px;
        height: 20px;
    }

    .left-button {
        left: 5px;
    }

    .right-button {
        right: 5px;
    }

    .market-image-item {
        max-width: 200px;
        min-width: 150px;
        padding: 15px;
    }

    .certificate-image-container {
        width: 200px;
        height: 140px;
    }

    .certificate-title {
        font-size: 16px;
    }

    .certificate-subtitle {
        font-size: 12px;
    }

    .certificate-placeholder {
        width: 150px;
        height: 120px;
    }

    .certificate-icon {
        font-size: 36px;
    }

    .certificate-placeholder h4 {
        font-size: 12px;
    }

    .innovation-item,
    .market-item {
        width: 100%;
        max-width: 300px;
    }
}

@media (max-width: 768px) {
    .enterprise-honor-tabs {
        padding: 0 15px;
    }

    .strategy-container {
        padding: 0 15px;
    }

    .strategy-row {
        flex-direction: column;
        gap: 15px;
    }

    .strategy-item {
        min-height: 250px;
        height: auto;
    }

    .strategy-item.expanded {
        min-height: 300px;
    }

    .strategy-title {
        font-size: 16px;
    }

    .strategy-subtitle {
        font-size: 11px;
    }

    .strategy-content {
        font-size: 12px;
        padding: 8px;
    }

    .honor-tabs-container {
        flex-direction: column;
        gap: 10px;
        max-width: 400px;
        align-items: center;
    }

    .honor-tab-wrapper {
        margin-right: 0;
        margin-bottom: 10px;
        width: 100%;
        max-width: 200px;
    }

    .honor-tab {
        padding: 12px 20px;
        font-size: 14px;
        margin: 0;
        clip-path: none;
        border-radius: 25px;
        width: 100%;
    }

    .honor-content {
        padding: 20px;
    }

    .honor-description {
        font-size: 14px;
    }

    .certificate-image-container {
        width: 180px;
        height: 120px;
    }

    .certificate-title {
        font-size: 14px;
    }

    .certificate-subtitle {
        font-size: 11px;
    }

    .certificate-placeholder {
        width: 120px;
        height: 90px;
    }

    .certificate-icon {
        font-size: 28px;
        margin-bottom: 5px;
    }

    .certificate-placeholder h4 {
        font-size: 10px;
    }

    .label-title {
        font-size: 12px;
    }

    .label-subtitle {
        font-size: 10px;
    }

    .innovation-item,
    .market-item {
        width: 100%;
        padding: 20px;
    }

    .market-images-container {
        gap: 10px;
        flex-wrap: nowrap;
        overflow: hidden;
    }

    .market-carousel-wrapper {
        padding: 15px 10px;
    }

    .carousel-nav-btn {
        width: 35px;
        height: 35px;
    }

    .carousel-nav-btn img {
        width: 18px;
        height: 18px;
    }

    .left-button {
        left: 0px;
    }

    .right-button {
        right: 0px;
    }

    .market-image-item {
        flex: 0 0 calc(50% - 5px);
        max-width: calc(50% - 5px);
        min-width: 140px;
        padding: 8px;
    }

    .market-carousel-indicators {
        bottom: -15px;
        gap: 8px;
    }

    .indicator-dot {
        width: 6px;
        height: 6px;
    }

    .indicator-dot.active {
        width: 18px;
    }

    .innovation-item h4,
    .market-item h4 {
        font-size: 16px;
    }

    .innovation-item p,
    .market-item p {
        font-size: 13px;
    }
}

@media (max-width: 480px) {
    .honor-tabs-container {
        max-width: 300px;
    }

    .honor-tab-wrapper {
        max-width: 150px;
    }

    .honor-tab {
        padding: 10px 15px;
        font-size: 13px;
    }

    .honor-content {
        padding: 15px;
    }

    .certificates-grid,
    .innovation-content,
    .market-content,
    .market-images-container {
        gap: 15px;
    }

    .market-images-container {
        gap: 15px;
    }

    .market-carousel-wrapper {
        padding: 10px 5px;
    }

    .carousel-nav-btn {
        width: 30px;
        height: 30px;
    }

    .carousel-nav-btn img {
        width: 16px;
        height: 16px;
    }

    .left-button {
        left: -5px;
    }

    .right-button {
        right: -5px;
    }

    .market-image-item {
        padding: 10px;
    }

    .certificate-image-container {
        width: 150px;
        height: 100px;
    }

    .certificate-title {
        font-size: 12px;
    }

    .certificate-subtitle {
        font-size: 10px;
    }

    .certificate-placeholder {
        width: 100px;
        height: 80px;
    }

    .certificate-icon {
        font-size: 24px;
    }

    .certificate-placeholder h4 {
        font-size: 9px;
    }

    .innovation-item,
    .market-item {
        padding: 15px;
    }

    .innovation-icon,
    .market-icon {
        font-size: 28px;
    }

    .innovation-item h4,
    .market-item h4 {
        font-size: 14px;
    }

    .innovation-item p,
    .market-item p {
        font-size: 12px;
    }
}

/* 底部导航栏 */
.footer {
    width: 100%;
    height: 340px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    color: #000;
    position: absolute;
    bottom: 0;
}

.footer_top {
    width: 100%;
    height: 300px;
    border-bottom: 1px solid #fff;
    display: flex;
    justify-content: center;
    padding-top: 30px;

}

.footerTopLeft {
    width: 50%;
    height: 210px;
    display: flex;
    justify-content: space-around;
    /* border: 1px solid; */
    margin-top: 20px;
}

.LeftCon p {
    font-size: 27rpx;
    text-align: center;
    color: #989898;
    cursor: pointer;
    line-height: 2.5;
}

.LeftCon h4 {
    color: #000;
    text-align: center;
    cursor: pointer;
    font-size: 18px;
}

.RightCon p {
    color: #989898;
    cursor: pointer;
}

/* 右边四个 */
.footerTopRight {
    height: 240px;
    font-size: 14px;
    position: relative;
    left: 3%;
    width: 40%;
}

.RightCon {
    height: 18%;
    display: flex;
    align-items: center;
}

.RightCon img {
    width: 25px;
    height: 25px;
    margin-right: 15px;
}

.RightCon p {
    color: #000;
    margin: 0;
    line-height: 25px;
}



.footerMidd {
    width: 70%;
    height: 75%;
    border-bottom: 1px solid #cacaca;
}

.code {
    position: absolute;
    right: 18%;
    top: 0;
    width: 35%;
    align-items: center;
    justify-content: space-around;
    display: flex;
}

.codes {
    width: 23%;
    height: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.codes img {
    width: 100%;
    height: 100%;
}

.code h5 {
    margin-top: 10px;
}

.footer_botm {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    font-size: 16px;

}


/* 图片动画 - 从右往左居中 */
.card-imgs {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0;
    object-fit: fill;
    position: relative;
}

.vjs-custom-skin {
    width: 100%;
    height: 100%;
}

.video-js {
    width: 100% !important;
    height: 100% !important;
    min-height: 300px;
}

.video-js video {
    object-fit: cover;
}

/* 响应式布局调整 */
@media (max-width: 768px) {
    .card-imgs {
        max-width: 100%;
        margin-right: 0;
    }

    .card-imgs .video-js {
        min-height: 250px;
    }
}

.gradient-con {
    position: absolute;
    margin-top: -380px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.gradient-text {
    font-size: 70px;
    /* 设置字体大小 */
    font-weight: bold;
    /* 可选的加粗 */
    background: linear-gradient(90deg, #30EDFC 0%, #304EFC 100%);
    -webkit-background-clip: text;
    /* Safari和Chrome支持 */
    background-clip: text;
    /* 适用于Firefox */
    color: transparent;
    /* 使文字透明，从而显示背景渐变 */
    padding-bottom: 30px;
}

.gradient-p {
    font-size: 40px;
    /* 设置字体大小 */
    font-weight: bold;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/IntoZhg.vue